"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var index_exports = {};
__export(index_exports, {
  AliChatModel: () => AliChatModel,
  AliEmbedModel: () => AliEmbedModel,
  AnthropicChatModel: () => AnthropicChatModel,
  AnthropicChatRoleEnum: () => AnthropicChatRoleEnum,
  BDUChatRoleEnum: () => BDUChatRoleEnum,
  BaiduChatModel: () => BaiduChatModel,
  ChatModel: () => ChatModel,
  ChatModelProvider: () => ChatModelProvider,
  ChatRoleEnum: () => ChatRoleEnum,
  DETaskType: () => DETaskType,
  DSChatRoleEnum: () => DSChatRoleEnum,
  DeepSeekChatModel: () => DeepSeekChatModel,
  EmbedModel: () => EmbedModel,
  EmbedModelProvider: () => EmbedModelProvider,
  GEMChatRoleEnum: () => GEMChatRoleEnum,
  GLMChatModel: () => GLMChatModel,
  GLMChatRoleEnum: () => GLMChatRoleEnum,
  GLMEmbedModel: () => GLMEmbedModel,
  GPTChatRoleEnum: () => GPTChatRoleEnum,
  GoogleChatModel: () => GoogleChatModel,
  GoogleEmbedModel: () => GoogleEmbedModel,
  IFlyTekChatModel: () => IFlyTekChatModel,
  IFlyTekImagineModel: () => IFlyTekImagineModel,
  ImagineModel: () => ImagineModel,
  ImagineModelProvider: () => ImagineModelProvider,
  ImgTaskType: () => ImgTaskType,
  MJTaskType: () => MJTaskType,
  MidJourneyImagineModel: () => MidJourneyImagineModel,
  ModelModel: () => ModelModel,
  ModelProvider: () => ModelProvider,
  MoonShotChatModel: () => MoonShotChatModel,
  OpenAIChatModel: () => OpenAIChatModel,
  OpenAIEmbedModel: () => OpenAIEmbedModel,
  OpenAIImagineModel: () => OpenAIImagineModel,
  OtherEmbedModel: () => OtherEmbedModel,
  Prompt: () => Prompt,
  SDTaskType: () => SDTaskType,
  SPKChatRoleEnum: () => SPKChatRoleEnum,
  SPKTaskType: () => SPKTaskType,
  StabilityAIImagineModel: () => StabilityAIImagineModel,
  XAIChatModel: () => XAIChatModel,
  default: () => index_default
});
module.exports = __toCommonJS(index_exports);

// interface/Enum.ts
var ChatModelProvider = /* @__PURE__ */ ((ChatModelProvider2) => {
  ChatModelProvider2["OpenAI"] = "openai";
  ChatModelProvider2["Anthropic"] = "anthropic";
  ChatModelProvider2["DeepSeek"] = "deepseek";
  ChatModelProvider2["IFlyTek"] = "iflytek";
  ChatModelProvider2["Baidu"] = "baidu";
  ChatModelProvider2["Google"] = "google";
  ChatModelProvider2["GLM"] = "glm";
  ChatModelProvider2["MoonShot"] = "moonshot";
  ChatModelProvider2["AliYun"] = "aliyun";
  ChatModelProvider2["XAI"] = "xai";
  ChatModelProvider2["Other"] = "other";
  return ChatModelProvider2;
})(ChatModelProvider || {});
var EmbedModelProvider = /* @__PURE__ */ ((EmbedModelProvider2) => {
  EmbedModelProvider2["OpenAI"] = "openai";
  EmbedModelProvider2["Google"] = "google";
  EmbedModelProvider2["GLM"] = "glm";
  EmbedModelProvider2["AliYun"] = "aliyun";
  EmbedModelProvider2["Other"] = "other";
  return EmbedModelProvider2;
})(EmbedModelProvider || {});
var ImagineModelProvider = /* @__PURE__ */ ((ImagineModelProvider2) => {
  ImagineModelProvider2["OpenAI"] = "openai";
  ImagineModelProvider2["MidJourney"] = "midjourney";
  ImagineModelProvider2["StabilityAI"] = "stability.ai";
  ImagineModelProvider2["IFlyTek"] = "iflytek";
  return ImagineModelProvider2;
})(ImagineModelProvider || {});
var ModelProvider = { ...ChatModelProvider, ...EmbedModelProvider, ...ImagineModelProvider };
var OpenAIEmbedModel = /* @__PURE__ */ ((OpenAIEmbedModel2) => {
  OpenAIEmbedModel2["ADA"] = "text-embedding-ada-002";
  OpenAIEmbedModel2["LARGE"] = "text-embedding-3-large";
  OpenAIEmbedModel2["SMALL"] = "text-embedding-3-small";
  return OpenAIEmbedModel2;
})(OpenAIEmbedModel || {});
var OtherEmbedModel = /* @__PURE__ */ ((OtherEmbedModel2) => {
  OtherEmbedModel2["BGE_M3"] = "bge-m3";
  OtherEmbedModel2["BASE_CHN"] = "text2vec-base-chinese";
  OtherEmbedModel2["LARGE_CHN"] = "text2vec-large-chinese";
  OtherEmbedModel2["BASE_CHN_PARAPH"] = "text2vec-base-chinese-paraphrase";
  OtherEmbedModel2["BASE_CHN_SENTENCE"] = "text2vec-base-chinese-sentence";
  OtherEmbedModel2["BASE_MUL"] = "text2vec-base-multilingual";
  OtherEmbedModel2["PARAPH_MUL_MINI"] = "paraphrase-multilingual-MiniLM-L12-v2";
  return OtherEmbedModel2;
})(OtherEmbedModel || {});
var GLMEmbedModel = /* @__PURE__ */ ((GLMEmbedModel2) => {
  GLMEmbedModel2["EMBED_2"] = "embedding-2";
  GLMEmbedModel2["EMBED_3"] = "embedding-3";
  return GLMEmbedModel2;
})(GLMEmbedModel || {});
var GoogleEmbedModel = /* @__PURE__ */ ((GoogleEmbedModel2) => {
  GoogleEmbedModel2["GEM_EMBED"] = "gemini-embedding-exp";
  return GoogleEmbedModel2;
})(GoogleEmbedModel || {});
var AliEmbedModel = /* @__PURE__ */ ((AliEmbedModel2) => {
  AliEmbedModel2["ALI_V3"] = "text-embedding-v3";
  AliEmbedModel2["ALI_V2"] = "text-embedding-v2";
  AliEmbedModel2["ALI_V1"] = "text-embedding-v1";
  AliEmbedModel2["ALI_ASYNC_V2"] = "text-embedding-async-v2";
  AliEmbedModel2["ALI_ASYNC_V1"] = "text-embedding-async-v1";
  return AliEmbedModel2;
})(AliEmbedModel || {});
var EmbedModel = {
  ...OpenAIEmbedModel,
  ...OtherEmbedModel,
  ...GLMEmbedModel,
  ...GoogleEmbedModel,
  ...AliEmbedModel
};
var OpenAIChatModel = /* @__PURE__ */ ((OpenAIChatModel2) => {
  OpenAIChatModel2["GPT3"] = "gpt-3.5-turbo";
  OpenAIChatModel2["GPT4"] = "gpt-4";
  OpenAIChatModel2["GPT4_TURBO"] = "gpt-4-turbo";
  OpenAIChatModel2["GPT_4O_MINI"] = "gpt-4o-mini";
  OpenAIChatModel2["GPT_4_1_MINI"] = "gpt-4.1-mini";
  OpenAIChatModel2["GPT_4_1_NANO"] = "gpt-4.1-nano";
  OpenAIChatModel2["GPT_4_1"] = "gpt-4.1";
  OpenAIChatModel2["CHAT_GPT_4O"] = "chatgpt-4o-latest";
  OpenAIChatModel2["GPT_4O"] = "gpt-4o";
  OpenAIChatModel2["GPT_4O_AUDIO"] = "gpt-4o-audio-preview";
  OpenAIChatModel2["O1"] = "o1";
  OpenAIChatModel2["O1_MINI"] = "o1-mini";
  OpenAIChatModel2["O1_PRO"] = "o1-pro";
  OpenAIChatModel2["O3_MINI"] = "o3-mini";
  return OpenAIChatModel2;
})(OpenAIChatModel || {});
var AnthropicChatModel = /* @__PURE__ */ ((AnthropicChatModel2) => {
  AnthropicChatModel2["CLAUDE_4_SONNET"] = "claude-sonnet-4-20250514";
  AnthropicChatModel2["CLAUDE_4_OPUS"] = "claude-opus-4-20250514";
  AnthropicChatModel2["CLAUDE_3_7_SONNET"] = "claude-3-7-sonnet-20250219";
  AnthropicChatModel2["CLAUDE_3_5_SONNET"] = "claude-3-5-sonnet-20241022";
  AnthropicChatModel2["CLAUDE_3_5_HAIKU"] = "claude-3-5-haiku-20241022";
  AnthropicChatModel2["CLAUDE_3_OPUS"] = "claude-3-opus-20240229";
  AnthropicChatModel2["CLAUDE_3_SONNET"] = "claude-3-sonnet-20240229";
  AnthropicChatModel2["CLAUDE_3_HAIKU"] = "claude-3-haiku-20240307";
  return AnthropicChatModel2;
})(AnthropicChatModel || {});
var DeepSeekChatModel = /* @__PURE__ */ ((DeepSeekChatModel2) => {
  DeepSeekChatModel2["DEEPSEEK_V3"] = "deepseek-chat";
  DeepSeekChatModel2["DEEPSEEK_R1"] = "deepseek-reasoner";
  return DeepSeekChatModel2;
})(DeepSeekChatModel || {});
var GoogleChatModel = /* @__PURE__ */ ((GoogleChatModel2) => {
  GoogleChatModel2["GEM_PRO_1_5"] = "gemini-1.5-pro";
  GoogleChatModel2["GEM_FLASH_1_5"] = "gemini-1.5-flash";
  GoogleChatModel2["GEM_FLASH_1_5_8B"] = "gemini-1.5-flash-8b";
  GoogleChatModel2["GEM_FLASH_2"] = "gemini-2.0-flash";
  GoogleChatModel2["GEM_FLASH_2_LITE"] = "gemini-2.0-flash-lite";
  GoogleChatModel2["GEM_PRO_2_5"] = "gemini-2.5-pro";
  GoogleChatModel2["GEM_FLASH_2_5"] = "gemini-2.5-flash";
  GoogleChatModel2["GEM_FLASH_2_5_LITE"] = "gemini-2.5-flash-lite";
  return GoogleChatModel2;
})(GoogleChatModel || {});
var GLMChatModel = /* @__PURE__ */ ((GLMChatModel2) => {
  GLMChatModel2["GLM_3_TURBO"] = "glm-3-turbo";
  GLMChatModel2["GLM_4"] = "glm-4";
  GLMChatModel2["GLM_4_AIR"] = "glm-4-air";
  GLMChatModel2["GLM_4_AIRX"] = "glm-4-airx";
  GLMChatModel2["GLM_4_FLASH"] = "glm-4-flash";
  GLMChatModel2["GLM_4_FLASHX"] = "glm-4-flashx";
  GLMChatModel2["GLM_4V"] = "glm-4v";
  GLMChatModel2["GLM_4V_PLUS"] = "glm-4v-plus";
  GLMChatModel2["GLM_4_LONG"] = "glm-4-long";
  GLMChatModel2["GLM_4_PLUS"] = "glm-4-plus";
  return GLMChatModel2;
})(GLMChatModel || {});
var BaiduChatModel = /* @__PURE__ */ ((BaiduChatModel2) => {
  BaiduChatModel2["ERNIE_3_5"] = "completions";
  BaiduChatModel2["ERNIE_3_5_PRE"] = "ernie-3.5-8k-preview";
  BaiduChatModel2["ERNIE_3_5_128K"] = "ernie-3.5-128k";
  BaiduChatModel2["ERNIE_4_0_LATEST"] = "ernie-4.0-8k-latest";
  BaiduChatModel2["ERNIE_4_0_PREVIEW"] = "ernie-4.0-8k-preview";
  BaiduChatModel2["ERNIE_4_0_8K"] = "completions_pro";
  BaiduChatModel2["ERNIE_4_0_TURBO_LATEST"] = "ernie-4.0-turbo-8k-latest";
  BaiduChatModel2["ERNIE_4_0_TURBO_PREVIEW"] = "ernie-4.0-turbo-8k-preview";
  BaiduChatModel2["ERNIE_4_0_TURBO_8K"] = "ernie-4.0-turbo-8k";
  BaiduChatModel2["ERNIE_4_0_TURBO_128K"] = "ernie-4.0-turbo-128k";
  BaiduChatModel2["ERNIE_SPEED_8K"] = "ernie_speed";
  BaiduChatModel2["ERNIE_SPEED_128K"] = "ernie-speed-128k";
  BaiduChatModel2["ERNIE_SPEED_PRO_128K"] = "ernie-speed-pro-128k";
  BaiduChatModel2["ERNIE_LITE_8K"] = "ernie-lite-8k";
  BaiduChatModel2["ERNIE_LITE_PRO_128K"] = "ernie-lite-pro-128k";
  BaiduChatModel2["ERNIE_TINY_8K"] = "ernie-tiny-8k";
  BaiduChatModel2["ERNIE_CHAR_8K"] = "ernie-char-8k";
  BaiduChatModel2["ERNIE_CHAR_FICTION_8K"] = "ernie-char-fiction-8k";
  BaiduChatModel2["ERNIE_NOVEL_8K"] = "ernie-novel-8k";
  return BaiduChatModel2;
})(BaiduChatModel || {});
var IFlyTekChatModel = /* @__PURE__ */ ((IFlyTekChatModel2) => {
  IFlyTekChatModel2["SPARK_LITE"] = "lite";
  IFlyTekChatModel2["SPARK_PRO"] = "generalv3";
  IFlyTekChatModel2["SPARK_PRO_128K"] = "pro-128k";
  IFlyTekChatModel2["SPARK_MAX"] = "generalv3.5";
  IFlyTekChatModel2["SPARK_MAX_32K"] = "max-32k";
  IFlyTekChatModel2["SPARK_ULTRA"] = "4.0Ultra";
  return IFlyTekChatModel2;
})(IFlyTekChatModel || {});
var MoonShotChatModel = /* @__PURE__ */ ((MoonShotChatModel2) => {
  MoonShotChatModel2["MOON_V1_8K"] = "moonshot-v1-8k";
  MoonShotChatModel2["MOON_V1_32K"] = "moonshot-v1-32k";
  MoonShotChatModel2["MOON_V1_128K"] = "moonshot-v1-128k";
  return MoonShotChatModel2;
})(MoonShotChatModel || {});
var AliChatModel = /* @__PURE__ */ ((AliChatModel2) => {
  AliChatModel2["QWEN_MAX"] = "qwen-max";
  AliChatModel2["QWEN_PLUS"] = "qwen-plus";
  AliChatModel2["QWEN_TURBO"] = "qwen-turbo";
  AliChatModel2["QWEN_LONG"] = "qwen-long";
  AliChatModel2["QWEN_CODE"] = "qwen-coder-turbo";
  AliChatModel2["QWEN_MATH"] = "qwen-math-plus";
  AliChatModel2["QWEN_VL_MAX"] = "qwen-vl-max";
  AliChatModel2["QWEN_VL_PLUS"] = "qwen-vl-plus";
  return AliChatModel2;
})(AliChatModel || {});
var XAIChatModel = /* @__PURE__ */ ((XAIChatModel2) => {
  XAIChatModel2["GROK2"] = "grok-2";
  XAIChatModel2["GROK2_VISION"] = "grok-2-vision";
  XAIChatModel2["GROK3"] = "grok-3";
  XAIChatModel2["GROK3_VISION"] = "grok-3-vision";
  return XAIChatModel2;
})(XAIChatModel || {});
var ChatModel = {
  ...OpenAIChatModel,
  ...AnthropicChatModel,
  ...DeepSeekChatModel,
  ...BaiduChatModel,
  ...GLMChatModel,
  ...IFlyTekChatModel,
  ...GoogleChatModel,
  ...OpenAIChatModel,
  ...MoonShotChatModel,
  ...AliChatModel,
  ...XAIChatModel
};
var MidJourneyImagineModel = /* @__PURE__ */ ((MidJourneyImagineModel2) => {
  MidJourneyImagineModel2["MJ"] = "midjourney";
  return MidJourneyImagineModel2;
})(MidJourneyImagineModel || {});
var OpenAIImagineModel = /* @__PURE__ */ ((OpenAIImagineModel2) => {
  OpenAIImagineModel2["DALL_E_2"] = "dall-e-2";
  OpenAIImagineModel2["DALL_E_3"] = "dall-e-3";
  return OpenAIImagineModel2;
})(OpenAIImagineModel || {});
var StabilityAIImagineModel = /* @__PURE__ */ ((StabilityAIImagineModel2) => {
  StabilityAIImagineModel2["SD_1_6"] = "stable-diffusion-v1-6";
  StabilityAIImagineModel2["SD_XL_1024"] = "stable-diffusion-xl-1024-v1-0";
  return StabilityAIImagineModel2;
})(StabilityAIImagineModel || {});
var IFlyTekImagineModel = /* @__PURE__ */ ((IFlyTekImagineModel2) => {
  IFlyTekImagineModel2["V2"] = "v2.1";
  return IFlyTekImagineModel2;
})(IFlyTekImagineModel || {});
var ImagineModel = {
  ...OpenAIImagineModel,
  ...MidJourneyImagineModel,
  ...StabilityAIImagineModel,
  ...IFlyTekImagineModel
};
var ModelModel = { ...ChatModel, ...ImagineModel, ...EmbedModel };
var MJTaskType = /* @__PURE__ */ ((MJTaskType4) => {
  MJTaskType4["IMAGINE"] = "IMAGINE";
  MJTaskType4["UPSCALE"] = "UPSCALE";
  MJTaskType4["VARIATION"] = "VARIATION";
  MJTaskType4["REROLL"] = "REROLL";
  MJTaskType4["DESCRIBE"] = "DESCRIBE";
  MJTaskType4["BLEND"] = "BLEND";
  return MJTaskType4;
})(MJTaskType || {});
var DETaskType = /* @__PURE__ */ ((DETaskType2) => {
  DETaskType2["GENERATION"] = "generations";
  DETaskType2["EDIT"] = "edits";
  DETaskType2["VARIATION"] = "variation";
  return DETaskType2;
})(DETaskType || {});
var SDTaskType = /* @__PURE__ */ ((SDTaskType2) => {
  SDTaskType2["GENERATION"] = "generation";
  return SDTaskType2;
})(SDTaskType || {});
var SPKTaskType = /* @__PURE__ */ ((SPKTaskType2) => {
  SPKTaskType2["GENERATION"] = "generation";
  return SPKTaskType2;
})(SPKTaskType || {});
var ImgTaskType = { ...MJTaskType, ...DETaskType, ...SDTaskType, ...SPKTaskType };
var ChatRoleEnum = /* @__PURE__ */ ((ChatRoleEnum2) => {
  ChatRoleEnum2["SYSTEM"] = "system";
  ChatRoleEnum2["USER"] = "user";
  ChatRoleEnum2["ASSISTANT"] = "assistant";
  ChatRoleEnum2["TOOL"] = "tool";
  ChatRoleEnum2["DEV"] = "developer";
  return ChatRoleEnum2;
})(ChatRoleEnum || {});
var GPTChatRoleEnum = /* @__PURE__ */ ((GPTChatRoleEnum2) => {
  GPTChatRoleEnum2["SYSTEM"] = "system";
  GPTChatRoleEnum2["USER"] = "user";
  GPTChatRoleEnum2["ASSISTANT"] = "assistant";
  GPTChatRoleEnum2["DEV"] = "developer";
  GPTChatRoleEnum2["TOOL"] = "tool";
  return GPTChatRoleEnum2;
})(GPTChatRoleEnum || {});
var AnthropicChatRoleEnum = /* @__PURE__ */ ((AnthropicChatRoleEnum2) => {
  AnthropicChatRoleEnum2["USER"] = "user";
  AnthropicChatRoleEnum2["ASSISTANT"] = "assistant";
  return AnthropicChatRoleEnum2;
})(AnthropicChatRoleEnum || {});
var DSChatRoleEnum = /* @__PURE__ */ ((DSChatRoleEnum2) => {
  DSChatRoleEnum2["SYSTEM"] = "system";
  DSChatRoleEnum2["USER"] = "user";
  DSChatRoleEnum2["ASSISTANT"] = "assistant";
  DSChatRoleEnum2["TOOL"] = "tool";
  return DSChatRoleEnum2;
})(DSChatRoleEnum || {});
var SPKChatRoleEnum = /* @__PURE__ */ ((SPKChatRoleEnum2) => {
  SPKChatRoleEnum2["USER"] = "user";
  SPKChatRoleEnum2["ASSISTANT"] = "assistant";
  SPKChatRoleEnum2["SYSTEM"] = "system";
  SPKChatRoleEnum2["TOOL"] = "tool";
  return SPKChatRoleEnum2;
})(SPKChatRoleEnum || {});
var GLMChatRoleEnum = /* @__PURE__ */ ((GLMChatRoleEnum2) => {
  GLMChatRoleEnum2["SYSTEM"] = "system";
  GLMChatRoleEnum2["USER"] = "user";
  GLMChatRoleEnum2["ASSISTANT"] = "assistant";
  GLMChatRoleEnum2["TOOL"] = "tool";
  return GLMChatRoleEnum2;
})(GLMChatRoleEnum || {});
var GEMChatRoleEnum = /* @__PURE__ */ ((GEMChatRoleEnum2) => {
  GEMChatRoleEnum2["USER"] = "user";
  GEMChatRoleEnum2["MODEL"] = "model";
  return GEMChatRoleEnum2;
})(GEMChatRoleEnum || {});
var BDUChatRoleEnum = /* @__PURE__ */ ((BDUChatRoleEnum2) => {
  BDUChatRoleEnum2["USER"] = "user";
  BDUChatRoleEnum2["ASSISTANT"] = "assistant";
  return BDUChatRoleEnum2;
})(BDUChatRoleEnum || {});

// src/providers/OpenAI.ts
var import_stream = require("stream");
var import_node = __toESM(require("@server-sent-stream/node"));
var import_iconv_lite = require("iconv-lite");

// src/util.ts
var import_fs = require("fs");
var import_axios = __toESM(require("axios"));
var import_node_localstorage = require("node-localstorage");
var import_path = __toESM(require("path"));
var import_is_base64 = __toESM(require("is-base64"));
var localStorage = new import_node_localstorage.LocalStorage("./cache", Infinity);
var util_default = {
  /**
   * Performs an HTTP GET request.
   *
   * @param url - The URL to make the request to.
   * @param params - Optional request parameters.
   * @param config - Optional Axios request configuration.
   * @returns A Promise that resolves with the response data.
   */
  async get(url, params, config) {
    return (await import_axios.default.get(url, { params, ...config })).data;
  },
  /**
   * Performs an HTTP POST request.
   *
   * @param url - The URL to make the request to.
   * @param body - The request body.
   * @param config - Optional Axios request configuration.
   * @returns A Promise that resolves with the response data.
   */
  async post(url, body, config) {
    return (await import_axios.default.post(url, body, config)).data;
  },
  /**
   * Parses JSON from a string and returns it as a generic type T.
   *
   * @param str - The JSON string to parse.
   * @returns The parsed JSON as a generic type T.
   */
  json(str) {
    try {
      if (!str) return null;
      return JSON.parse(str);
    } catch (e) {
      return null;
    }
  },
  getRandomKey(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  },
  getRandomId(length = 16) {
    let result = "";
    while (result.length < length) {
      let rand = Math.floor(Math.random() * 10);
      if (result.length === 0 && rand === 0) continue;
      result += rand.toString();
    }
    return result;
  },
  /**
   * Computes the greatest common divisor (GCD) of two numbers using Euclidean algorithm.
   *
   * @param a - The first number.
   * @param b - The second number.
   * @returns The GCD of the two numbers.
   */
  getGCD(a, b) {
    if (b === 0) return a;
    return this.getGCD(b, a % b);
  },
  /**
   * Calculates and returns the aspect ratio of a width and height.
   *
   * @param width - The width dimension.
   * @param height - The height dimension.
   * @returns The aspect ratio in the format "width:height".
   */
  getAspect(width, height) {
    if (!width || !height) return "1:1";
    const gcd = this.getGCD(width, height);
    const aspectRatioWidth = width / gcd;
    const aspectRatioHeight = height / gcd;
    return `${aspectRatioWidth}:${aspectRatioHeight}`;
  },
  /**
   * Stores an item in local storage with the specified key.
   *
   * @param key - The key under which to store the item.
   * @param value - The value to be stored.
   */
  setItem(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  },
  /**
   * Retrieves an item from local storage by its key and parses it as a generic type T.
   *
   * @param key - The key of the item to retrieve.
   * @returns The parsed item as a generic type T.
   */
  getItem(key) {
    return this.json(localStorage.getItem(key));
  },
  /**
   * This method is used to write given data to a file. The data can either be a base64 string or an HTTP/HTTPS URL.
   * If the data is a URL, the method fetches the data as a readable stream and writes it to the file.
   * If it's a base64 string, it writes it directly to the file.
   * @param data - The data to be written to the file. Can be a base64 string or a HTTP/HTTPS img URL.
   * @param filename - The name of the file where the data will be written. If not provided, a unique filename will be generated.
   * @returns - The file path where the data was written.
   */
  async writeFile(data, filename = "") {
    const filepath = import_path.default.join("./cache", filename);
    if (data.startsWith("http://") || data.startsWith("https://")) {
      const res = await this.get(data, {}, { responseType: "arraybuffer" });
      if (!(res instanceof Buffer)) throw new Error("Img is not a buffer");
      (0, import_fs.writeFileSync)(filepath, res);
    } else (0, import_fs.writeFileSync)(filepath, Buffer.from(data, "base64"));
    return filepath;
  },
  isBase64(data, allowMime = true) {
    return (0, import_is_base64.default)(data, { allowMime });
  }
};

// src/providers/OpenAI.ts
var STORAGE_KEY = "task_open_ai";
var API = "https://api.openai.com";
var VER = "v1";
var OpenAI = class {
  /**
   * Constructor for the OpenAI class.
   *
   * @param key - The API key for OpenAI.
   * @param api - The API endpoint for proxy (optional).
   */
  constructor(key, api = API) {
    this.key = key;
    this.api = api;
  }
  /**
   * Fetches embeddings for input text.
   *
   * @param input - An array of input strings.
   * @param model - The model to use for embeddings (default: text-embedding-ada-002).
   * @returns A promise resolving to the embedding response.
   */
  async embedding(input, model = "text-embedding-ada-002" /* ADA */) {
    const key = Array.isArray(this.key) ? util_default.getRandomKey(this.key) : this.key;
    if (!key) throw new Error("OpenAI API key is not set in config");
    const res = await util_default.post(
      `${this.api}/${VER}/embeddings`,
      { model, input },
      { headers: { Authorization: `Bearer ${key}` }, responseType: "json" }
    );
    const data = {
      embedding: res.data.map((v) => v.embedding),
      object: "embedding",
      model,
      promptTokens: res.usage.prompt_tokens || 0,
      totalTokens: res.usage.total_tokens || 0
    };
    return data;
  }
  /**
   * Sends messages to the GPT chat model.
   *
   * @param messages - An array of chat messages.
   * @param model - The model to use for chat (default: gpt-3.5-turbo).
   * @param stream - Whether to use stream response (default: false).
   * @param top - Top probability to sample (optional).
   * @param temperature - Temperature for sampling (optional).
   * @param maxLength - Maximum token length for response (optional).
   * @param tools - Tools for model to use (optional).
   * @param toolChoice - Controls which (if any) tool is called by the model: none, required, auto (optional).
   * @returns A promise resolving to the chat response or a stream.
   */
  async chat(messages, model = "gpt-4.1" /* GPT_4_1 */, stream = false, top, temperature, maxLength, tools, toolChoice) {
    const key = Array.isArray(this.key) ? util_default.getRandomKey(this.key) : this.key;
    if (!key) throw new Error("OpenAI API key is not set in config");
    if (typeof temperature === "number") {
      if (temperature < 0) temperature = 0;
      if (temperature > 1) temperature = 1;
    }
    if (typeof top === "number") {
      if (top < 0) top = 0;
      if (top > 1) top = 1;
    }
    const res = await util_default.post(
      `${this.api}/${VER}/chat/completions`,
      {
        model,
        messages: this.formatMessage(messages),
        stream,
        temperature,
        top_p: top,
        max_completion_tokens: maxLength,
        tools,
        tool_choice: toolChoice
      },
      { headers: { Authorization: `Bearer ${key}` }, responseType: stream ? "stream" : "json" }
    );
    const data = {
      content: "",
      model,
      object: "",
      promptTokens: 0,
      completionTokens: 0,
      totalTokens: 0
    };
    if (res instanceof import_stream.Readable) {
      const output = new import_stream.PassThrough();
      const parser = new import_node.default();
      parser.on("data", (e) => {
        const obj = util_default.json(e.data);
        if (obj) {
          data.content = obj.choices[0]?.delta?.content || "";
          if (obj.choices[0]?.delta?.tool_calls) data.tools = obj.choices[0]?.delta?.tool_calls;
          data.model = obj.model;
          data.object = obj.object;
          data.promptTokens = obj.usage?.prompt_tokens || 0;
          data.completionTokens = obj.usage?.completion_tokens || 0;
          data.totalTokens = obj.usage?.total_tokens || 0;
          output.write(JSON.stringify(data));
        }
      });
      parser.on("error", (e) => output.destroy(e));
      parser.on("end", () => output.end());
      res.pipe((0, import_iconv_lite.decodeStream)("utf-8")).pipe(parser);
      return output;
    } else {
      data.content = res.choices[0]?.message?.content || "";
      if (res.choices[0]?.message?.tool_calls) data.tools = res.choices[0]?.message?.tool_calls;
      data.model = res.model;
      data.object = res.object;
      data.promptTokens = res.usage?.prompt_tokens || 0;
      data.completionTokens = res.usage?.completion_tokens || 0;
      data.totalTokens = res.usage?.total_tokens || 0;
      return data;
    }
  }
  /**
   * Generates images based on a prompt.
   *
   * @param prompt - The prompt for image generation.
   * @param width - Image width (default: 1024).
   * @param height - Image height (default: 1024).
   * @param n - Number of images to generate (default: 1).
   * @param model - Model choice (default: dall-e-3).
   * @returns A promise resolving to the image generation response.
   */
  async imagine(prompt, width = 1024, height = 1024, n = 1, model = "dall-e-3" /* DALL_E_3 */) {
    const key = Array.isArray(this.key) ? util_default.getRandomKey(this.key) : this.key;
    if (!key) throw new Error("OpenAI API key is not set in config");
    const res = await util_default.post(
      `${this.api}/${VER}/images/${"generations" /* GENERATION */}`,
      { model, prompt, n, size: `${width}x${height}`, response_format: "b64_json" },
      { headers: { Authorization: `Bearer ${key}` }, responseType: "json" }
    );
    const id = util_default.getRandomId();
    const imgs = [];
    for (const i in res.data) imgs.push(await util_default.writeFile(res.data[i].b64_json, `${id}-${i}.png`));
    const time = Date.now();
    const task = {
      id,
      type: "generations" /* GENERATION */,
      info: "success",
      progress: 100,
      imgs,
      fail: "",
      created: time,
      model
    };
    const tasks = util_default.getItem(STORAGE_KEY) || [];
    tasks.push(task);
    util_default.setItem(STORAGE_KEY, tasks);
    return { taskId: task.id, time };
  }
  /**
   * Simulate tasks.
   *
   * @param id - The task ID to retrieve (optional).
   * @returns An array of task responses or a specific task by ID.
   */
  task(id) {
    const tasks = util_default.getItem(STORAGE_KEY) || [];
    if (id) return tasks.filter((v) => v.id === id);
    else return tasks;
  }
  /**
   * Formats chat messages according to the GPT model's message format.
   *
   * @param messages - An array of chat messages.
   * @returns Formatted messages compatible with the GPT model.
   */
  formatMessage(messages) {
    const prompt = [];
    for (const { role, content, img, tool, audio } of messages) {
      switch (role) {
        case "user" /* USER */:
          if (img || audio) {
            const contentArr = [];
            if (content.trim()) contentArr.push({ type: "text", text: content });
            if (img) contentArr.push({ type: "image_url", image_url: { url: img } });
            if (audio) contentArr.push({ type: "input_audio", input_audio: { data: audio, format: "wav" } });
            prompt.push({ role, content: contentArr });
          } else prompt.push({ role, content });
          break;
        case "tool" /* TOOL */:
          prompt.push({ role, content, tool_call_id: tool });
          break;
        default:
          prompt.push({ role, content });
          break;
      }
    }
    return prompt;
  }
};

// src/providers/Anthropic.ts
var import_stream2 = require("stream");
var import_node2 = __toESM(require("@server-sent-stream/node"));
var import_iconv_lite2 = require("iconv-lite");
var import_path2 = require("path");
var import_fs2 = require("fs");
var API2 = "https://api.anthropic.com";
var VER2 = "v1";
var Anthropic = class {
  /**
   * Constructor for the Anthropic class.
   *
   * @param key - The API key for Anthropic.
   * @param api - The API endpoint for proxy (optional).
   */
  constructor(key, api = API2) {
    this.key = key;
    this.api = api;
  }
  /**
   * Sends messages to the Claude chat model.
   *
   * @param messages - An array of chat messages.
   * @param model - The model to use for chat (default: claude-3-5-sonnet).
   * @param stream - Whether to use stream response (default: false).
   * @param top - Top probability to sample (optional).
   * @param temperature - Temperature for sampling (optional).
   * @param maxLength - Maximum token length for response (optional).
   * @param tools - Tools for model to use (optional).
   * @param toolChoice - Controls which (if any) tool is called by the model (optional).
   * @returns A promise resolving to the chat response or a stream.
   */
  async chat(messages, model = "claude-3-5-sonnet-20241022" /* CLAUDE_3_5_SONNET */, stream = false, top, temperature, maxLength, tools, toolChoice) {
    const key = Array.isArray(this.key) ? util_default.getRandomKey(this.key) : this.key;
    if (!key) throw new Error("Anthropic API key is not set in config");
    if (typeof temperature === "number") {
      if (temperature < 0) temperature = 0;
      if (temperature > 1) temperature = 1;
    }
    if (typeof top === "number") {
      if (top < 0) top = 0;
      if (top > 1) top = 1;
    }
    const { formattedMessages, systemMessage } = await this.formatMessage(messages);
    const anthropicTools = tools ? this.formatTools(tools) : void 0;
    const anthropicToolChoice = toolChoice ? this.formatToolChoice(toolChoice) : void 0;
    const requestBody = {
      model,
      max_tokens: maxLength || 4096,
      messages: formattedMessages,
      stream,
      temperature,
      top_p: top,
      ...systemMessage && { system: systemMessage },
      ...anthropicTools && { tools: anthropicTools },
      ...anthropicToolChoice && { tool_choice: anthropicToolChoice }
    };
    const res = await util_default.post(
      `${this.api}/${VER2}/messages`,
      requestBody,
      {
        headers: {
          "x-api-key": key,
          "anthropic-version": "2023-06-01",
          "Content-Type": "application/json"
        },
        responseType: stream ? "stream" : "json"
      }
    );
    const data = {
      content: "",
      model,
      object: "",
      promptTokens: 0,
      completionTokens: 0,
      totalTokens: 0
    };
    if (res instanceof import_stream2.Readable) {
      const output = new import_stream2.PassThrough();
      const parser = new import_node2.default();
      parser.on("data", (e) => {
        const obj = util_default.json(e.data);
        if (obj) {
          switch (obj.type) {
            case "message_start":
              if (obj.message?.usage) {
                data.promptTokens = obj.message.usage.input_tokens;
              }
              break;
            case "content_block_delta":
              if (obj.delta?.text) {
                data.content = obj.delta.text;
                data.object = "chat.completion.chunk";
                output.write(JSON.stringify(data));
              }
              break;
            case "message_delta":
              if (obj.delta?.usage?.output_tokens) {
                data.completionTokens = obj.delta.usage.output_tokens;
                data.totalTokens = data.promptTokens + data.completionTokens;
              }
              break;
            case "message_stop":
              break;
          }
        }
      });
      parser.on("error", (e) => output.destroy(e));
      parser.on("end", () => output.end());
      res.pipe((0, import_iconv_lite2.decodeStream)("utf-8")).pipe(parser);
      return output;
    } else {
      if (res.content && res.content.length > 0) {
        const textContent = res.content.find((c) => c.type === "text");
        if (textContent) {
          data.content = textContent.text || "";
        }
        const toolUseContent = res.content.filter((c) => c.type === "tool_use");
        if (toolUseContent.length > 0) {
          data.tools = toolUseContent.map((tool) => ({
            id: tool.id,
            type: "function",
            function: {
              name: tool.name,
              arguments: JSON.stringify(tool.input)
            }
          }));
        }
      }
      data.model = res.model;
      data.object = "chat.completion";
      data.promptTokens = res.usage?.input_tokens || 0;
      data.completionTokens = res.usage?.output_tokens || 0;
      data.totalTokens = data.promptTokens + data.completionTokens;
      return data;
    }
  }
  /**
   * Formats chat messages according to the Claude model's message format.
   *
   * @param messages - An array of chat messages.
   * @returns Formatted messages and system message compatible with the Claude model.
   */
  async formatMessage(messages) {
    const formattedMessages = [];
    let systemMessage = "";
    for (const { role, content, img, audio } of messages) {
      if (role === "system" /* SYSTEM */) {
        systemMessage += content + "\n";
        continue;
      }
      if (role === "tool" /* TOOL */) {
        formattedMessages.push({
          role: "user" /* USER */,
          content: `Tool result: ${content}`
        });
        continue;
      }
      let claudeRole;
      switch (role) {
        case "user" /* USER */:
          claudeRole = "user" /* USER */;
          break;
        case "assistant" /* ASSISTANT */:
          claudeRole = "assistant" /* ASSISTANT */;
          break;
        default:
          claudeRole = "user" /* USER */;
          break;
      }
      if (img || audio) {
        const contentArray = [];
        if (content.trim()) {
          contentArray.push({ type: "text", text: content });
        }
        if (img) {
          const imageContent = await this.formatImage(img);
          if (imageContent) {
            contentArray.push(imageContent);
          }
        }
        if (audio) {
          contentArray.push({
            type: "text",
            text: "[Audio input provided but not supported by Claude API]"
          });
        }
        formattedMessages.push({
          role: claudeRole,
          content: contentArray
        });
      } else {
        formattedMessages.push({
          role: claudeRole,
          content
        });
      }
    }
    return {
      formattedMessages,
      systemMessage: systemMessage.trim() || void 0
    };
  }
  /**
   * Format image for Claude API
   * Supports: image/jpeg, image/png, image/gif, and image/webp
   */
  async formatImage(img) {
    try {
      let mediaType = "image/png";
      let base64Data = "";
      if (util_default.isBase64(img)) {
        if (util_default.isBase64(img, false)) {
          base64Data = img;
          mediaType = "image/png";
        } else {
          const match = img.match(/^data:image\/([a-zA-Z]*);base64,([^\"']*)$/);
          if (match) {
            mediaType = `image/${match[1]}`;
            base64Data = match[2];
          }
        }
      } else if (img.startsWith("http")) {
        const res = await util_default.get(img, {}, { responseType: "arraybuffer" });
        const supportedTypes = ["jpeg", "jpg", "png", "gif", "webp"];
        const detectedType = supportedTypes.find(
          (type) => img.toLowerCase().includes(`.${type}`) || img.toLowerCase().includes(`/${type}`)
        );
        if (detectedType) {
          mediaType = `image/${detectedType === "jpg" ? "jpeg" : detectedType}`;
        } else {
          mediaType = "image/jpeg";
        }
        base64Data = res.toString("base64");
      } else {
        const fileExtension = (0, import_path2.extname)(img).replace(".", "").toLowerCase();
        const supportedExtensions = ["jpeg", "jpg", "png", "gif", "webp"];
        if (supportedExtensions.includes(fileExtension)) {
          mediaType = `image/${fileExtension === "jpg" ? "jpeg" : fileExtension}`;
          base64Data = (0, import_fs2.readFileSync)(img).toString("base64");
        } else {
          throw new Error(`Unsupported image format: ${fileExtension}. Anthropic supports: jpeg, png, gif, webp`);
        }
      }
      if (!base64Data) {
        throw new Error("Failed to convert image to base64");
      }
      const supportedMediaTypes = ["image/jpeg", "image/png", "image/gif", "image/webp"];
      if (!supportedMediaTypes.includes(mediaType)) {
        console.warn(`Unsupported media type: ${mediaType}, defaulting to image/png`);
        mediaType = "image/png";
      }
      return {
        type: "image",
        source: {
          type: "base64",
          media_type: mediaType,
          data: base64Data
        }
      };
    } catch (error) {
      console.warn("Failed to format image for Claude:", error);
      return null;
    }
  }
  /**
   * Convert OpenAI tools format to Anthropic tools format
   */
  formatTools(tools) {
    return tools.map((tool) => ({
      name: tool.function.name,
      description: tool.function.description || "",
      input_schema: {
        type: "object",
        properties: tool.function.parameters?.properties || {},
        required: Array.isArray(tool.function.parameters?.required) ? tool.function.parameters.required : []
      }
    }));
  }
  /**
   * Convert OpenAI tool choice format to Anthropic tool choice format
   */
  formatToolChoice(toolChoice) {
    if (typeof toolChoice === "string") {
      switch (toolChoice) {
        case "none":
          return void 0;
        // Claude doesn't have explicit "none" option
        case "auto":
          return { type: "auto" };
        case "required":
          return { type: "any" };
        default:
          return { type: "auto" };
      }
    } else if (typeof toolChoice === "object" && toolChoice.type === "function") {
      return {
        type: "tool",
        name: toolChoice.function.name
      };
    }
    return void 0;
  }
};

// src/providers/GLM.ts
var import_stream3 = require("stream");
var import_node3 = __toESM(require("@server-sent-stream/node"));
var import_iconv_lite3 = require("iconv-lite");
var API3 = "https://open.bigmodel.cn";
var GLM = class {
  constructor(key, proxyAPI = API3) {
    this.key = key;
    this.proxyAPI = proxyAPI;
  }
  /**
   * Fetches embeddings for input text.
   *
   * @param input - An array of input strings.
   * @param model - The model to use for embeddings (default: text-embedding-ada-002).
   * @returns A promise resolving to the embedding response.
   */
  async embedding(input, model = "embedding-2" /* EMBED_2 */, dimensions = 1024) {
    const key = Array.isArray(this.key) ? util_default.getRandomKey(this.key) : this.key;
    if (!key) throw new Error("ZhiPu GLM API key is not set in config");
    const res = await util_default.post(
      `${this.proxyAPI}/api/paas/v4/embeddings`,
      { model, input, dimensions },
      { headers: { Authorization: `Bearer ${key}` }, responseType: "json" }
    );
    return {
      embedding: res.data.map((v) => v.embedding),
      object: "embedding",
      model,
      promptTokens: res.usage.prompt_tokens,
      totalTokens: res.usage.total_tokens
    };
  }
  /**
   * Sends messages to the GLM chat model.
   *
   * @param messages - An array of chat messages.
   * @param model - The model to use for chat (default: GLM_6B a local deployed chatglm3-6b-32k).
   * @param stream - Whether to use stream response (default: false).
   * @param top - Top probability to sample (optional).
   * @param temperature - Temperature for sampling (optional).
   * @param maxLength - Maximum token length for response (optional).
   * @returns A promise resolving to the chat response or a stream.
   */
  async chat(messages, model = "glm-3-turbo" /* GLM_3_TURBO */, stream = false, top, temperature, maxLength, tools, toolChoice) {
    if (!["glm-4v" /* GLM_4V */, "glm-4v-plus" /* GLM_4V_PLUS */].includes(model))
      messages = messages.map(({ role, content }) => ({ role, content }));
    if (typeof temperature === "number") {
      if (temperature <= 0) temperature = 0.1;
      if (temperature > 1) temperature = 1;
    }
    if (typeof top === "number") {
      if (top <= 0) top = 0.1;
      if (top >= 1) top = 0.9;
    }
    const data = {
      content: "",
      model,
      object: "",
      promptTokens: 0,
      completionTokens: 0,
      totalTokens: 0
    };
    const key = Array.isArray(this.key) ? util_default.getRandomKey(this.key) : this.key;
    if (!key) throw new Error("ZhiPu GLM API key is not set in config");
    const res = await util_default.post(
      `${this.proxyAPI}/api/paas/v4/chat/completions`,
      {
        model,
        messages: this.formatMessage(messages),
        stream,
        temperature,
        top_p: top,
        max_tokens: maxLength,
        tools,
        tool_choice: toolChoice
      },
      { headers: { Authorization: `Bearer ${key}` }, responseType: stream ? "stream" : "json" }
    );
    if (res instanceof import_stream3.Readable) {
      const output = new import_stream3.PassThrough();
      const parser = new import_node3.default();
      parser.on("data", (e) => {
        const obj = util_default.json(e.data);
        if (obj) {
          data.content = obj.choices[0]?.delta?.content || "";
          if (obj.choices[0]?.delta?.tool_calls) data.tools = obj.choices[0]?.delta?.tool_calls;
          data.model = obj.model;
          data.object = obj.object || "chat.completion.chunk";
          data.promptTokens = obj.usage?.prompt_tokens || 0;
          data.completionTokens = obj.usage?.completion_tokens || 0;
          data.totalTokens = obj.usage?.total_tokens || 0;
          if (data.content) output.write(JSON.stringify(data));
        }
      });
      parser.on("error", (e) => output.destroy(e));
      parser.on("end", () => output.end());
      res.pipe((0, import_iconv_lite3.decodeStream)("utf-8")).pipe(parser);
      return output;
    } else {
      data.content = res.choices[0]?.message?.content || "";
      if (res.choices[0]?.message?.tool_calls) data.tools = res.choices[0]?.message?.tool_calls;
      data.model = res.model;
      data.object = res.object || "chat.completion";
      data.promptTokens = res.usage?.prompt_tokens || 0;
      data.completionTokens = res.usage?.completion_tokens || 0;
      data.totalTokens = res.usage?.total_tokens || 0;
      return data;
    }
  }
  /**
   * Formats chat messages according to the GPT model's message format.
   *
   * @param messages - An array of chat messages.
   * @returns Formatted messages compatible with the GPT model.
   */
  formatMessage(messages) {
    const prompt = [];
    for (const { role, content, img, tool } of messages) {
      if (role === "developer" /* DEV */) continue;
      switch (role) {
        case "user" /* USER */:
          if (img)
            prompt.push({
              role,
              content: [
                { type: "text", text: content },
                { type: "image_url", image_url: { url: img } }
              ]
            });
          else prompt.push({ role, content });
          break;
        case "tool" /* TOOL */:
          prompt.push({
            role,
            content,
            tool_call_id: tool || ""
          });
          break;
        default:
          prompt.push({ role, content });
          break;
      }
    }
    return prompt;
  }
};

// src/providers/Other.ts
var import_iconv_lite4 = require("iconv-lite");
var import_stream4 = require("stream");
var import_node4 = __toESM(require("@server-sent-stream/node"));
var Other = class {
  /**
   * Constructor for the OpenAI class.
   *
   * @param api - The API endpoint for the model (optional).
   * @param key - The API key for the model (Optional).
   */
  constructor(api, key) {
    this.api = api;
    this.key = key;
  }
  /**
   * Fetches embeddings for input text.
   *
   * @param input - An array of input strings.
   * @param model - The model to use for embeddings (default: text-embedding-ada-002).
   * @returns A promise resolving to the embedding response.
   */
  async embedding(input, model = EmbedModel.BGE_M3) {
    if (!this.api) throw new Error("Other embed model API is not set in config");
    const key = Array.isArray(this.key) ? util_default.getRandomKey(this.key) : this.key;
    const res = await util_default.post(
      `${this.api}/v1/embeddings`,
      { model, input },
      { headers: { Authorization: `Bearer ${key}` }, responseType: "json" }
    );
    const data = {
      embedding: res.data.map((v) => v.embedding),
      object: "embedding",
      model,
      promptTokens: res.usage.prompt_tokens || 0,
      totalTokens: res.usage.total_tokens || 0
    };
    return data;
  }
  /**
   * Sends messages to the GPT compatible chat model.
   *
   * @param messages - An array of chat messages.
   * @param model - The model to use for chat (default: gpt-3.5-turbo).
   * @param stream - Whether to use stream response (default: false).
   * @param top - Top probability to sample (optional).
   * @param temperature - Temperature for sampling (optional).
   * @param maxLength - Maximum token length for response (optional).
   * @returns A promise resolving to the chat response or a stream.
   */
  async chat(messages, model = ChatModel.GPT3, stream = false, top, temperature, maxLength, tools, toolChoice) {
    if (!this.api) throw new Error("Other chat model API is not set in config");
    const key = Array.isArray(this.key) ? util_default.getRandomKey(this.key) : this.key;
    const res = await util_default.post(
      `${this.api}/v1/chat/completions`,
      {
        model,
        messages: this.formatMessage(messages),
        stream,
        temperature,
        top_p: top,
        max_tokens: maxLength,
        tools,
        tool_choice: toolChoice
      },
      { headers: { Authorization: `Bearer ${key}` }, responseType: stream ? "stream" : "json" }
    );
    const data = {
      content: "",
      model,
      object: "",
      promptTokens: 0,
      completionTokens: 0,
      totalTokens: 0
    };
    if (res instanceof import_stream4.Readable) {
      const output = new import_stream4.PassThrough();
      const parser = new import_node4.default();
      parser.on("data", (e) => {
        const obj = util_default.json(e.data);
        if (obj) {
          data.content = obj.choices[0]?.delta?.content || "";
          if (obj.choices[0]?.delta?.tool_calls) data.tools = obj.choices[0]?.delta?.tool_calls;
          data.model = obj.model || model;
          data.object = obj.object || "chat.completion.chunk";
          data.promptTokens = obj.usage?.prompt_tokens || 0;
          data.completionTokens = obj.usage?.completion_tokens || 0;
          data.totalTokens = obj.usage?.total_tokens || 0;
          output.write(JSON.stringify(data));
        }
      });
      parser.on("error", (e) => output.destroy(e));
      parser.on("end", () => output.end());
      res.pipe((0, import_iconv_lite4.decodeStream)("utf-8")).pipe(parser);
      return output;
    } else {
      data.content = res.choices[0]?.message?.content || "";
      if (res.choices[0]?.message?.tool_calls) data.tools = res.choices[0]?.message?.tool_calls;
      data.model = res.model || model;
      data.object = res.object || "chat.completion";
      data.promptTokens = res.usage?.prompt_tokens || 0;
      data.completionTokens = res.usage?.completion_tokens || 0;
      data.totalTokens = res.usage?.total_tokens || 0;
      return data;
    }
  }
  /**
   * Formats chat messages according to the GPT model's message format.
   *
   * @param messages - An array of chat messages.
   * @returns Formatted messages compatible with the GPT model.
   */
  formatMessage(messages) {
    const prompt = [];
    for (const { role, content, img, tool } of messages) {
      switch (role) {
        case "user" /* USER */:
          if (img)
            prompt.push({
              role,
              content: [
                { type: "text", text: content },
                { type: "image_url", image_url: { url: img } }
              ]
            });
          else prompt.push({ role, content });
          break;
        case "tool" /* TOOL */:
          prompt.push({
            role,
            content,
            tool_call_id: tool || ""
          });
          break;
        default:
          prompt.push({ role, content });
          break;
      }
    }
    return prompt;
  }
};

// src/providers/Google.ts
var import_stream5 = require("stream");
var import_json_node = require("@streamparser/json-node");
var import_iconv_lite5 = require("iconv-lite");
var import_path3 = require("path");
var import_fs3 = require("fs");
var API4 = "https://generativelanguage.googleapis.com";
var SAFE_SET = [
  { category: "HARM_CATEGORY_HARASSMENT", threshold: "BLOCK_NONE" },
  { category: "HARM_CATEGORY_HATE_SPEECH", threshold: "BLOCK_NONE" },
  { category: "HARM_CATEGORY_SEXUALLY_EXPLICIT", threshold: "BLOCK_NONE" },
  { category: "HARM_CATEGORY_DANGEROUS_CONTENT", threshold: "BLOCK_NONE" }
];
var Google = class {
  /**
   * Google API client class for chat functionalities.
   * @param key - The Google API key or an array of keys.
   * @param api - The API endpoint (default: 'https://generativelanguage.googleapis.com').
   */
  constructor(key, api = API4) {
    this.key = key;
    this.api = api;
  }
  /**
   * Fetches embeddings for input text.
   *
   * @param input - An array of input strings.
   * @param model - The model to use for embeddings (default: text-embedding-ada-002).
   * @returns A promise resolving to the embedding response.
   */
  async embedding(input, model = "gemini-embedding-exp" /* GEM_EMBED */) {
    const key = Array.isArray(this.key) ? util_default.getRandomKey(this.key) : this.key;
    if (!key) throw new Error("Google API key is not set in config");
    const request = [];
    for (const text of input) {
      request.push(
        util_default.post(
          `${this.api}/v1beta/models/${model}:embedContent?key=${key}`,
          { model: `models/${model}`, content: { parts: [{ text }] } }
        )
      );
    }
    const res = await Promise.all(request);
    const data = {
      embedding: res.map((v) => v.embedding.values),
      object: "embedding",
      model,
      promptTokens: 0,
      totalTokens: 0
    };
    return data;
  }
  /**
   * Sends messages to the Google Gemini chat model.
   * @param messages - An array of chat messages.
   * @param model - The model to use for chat (default: gemini-pro).
   * @param stream - Whether to use stream response (default: false).
   * @param top - Top probability to sample (optional).
   * @param temperature - Temperature for sampling (optional).
   * @param maxLength - Maximum token length for response (optional).
   * @returns A promise resolving to the chat response or a stream.
   */
  async chat(messages, model = "gemini-1.5-pro" /* GEM_PRO_1_5 */, stream = false, top, temperature, maxLength) {
    const key = Array.isArray(this.key) ? util_default.getRandomKey(this.key) : this.key;
    if (!key) throw new Error("Google AI API key is not set in config");
    if (typeof temperature === "number") {
      if (temperature < 0) temperature = 0;
      if (temperature > 1) temperature = 1;
    }
    if (typeof top === "number") {
      if (top < 0) top = 0;
      if (top > 1) top = 1;
    }
    const res = await util_default.post(
      `${this.api}/v1beta/models/${model}:${stream ? "streamGenerateContent" : "generateContent"}?key=${key}`,
      {
        contents: await this.formatMessage(messages),
        system_instruction: {
          parts: {
            text: messages.filter((v) => v.role === "system" /* SYSTEM */).map((v) => v.content).join("\n")
          }
        },
        generationConfig: { topP: top, temperature, maxOutputTokens: maxLength },
        safetySettings: SAFE_SET
      },
      { responseType: stream ? "stream" : "json" }
    );
    const data = {
      content: "",
      model,
      object: "",
      promptTokens: 0,
      completionTokens: 0,
      totalTokens: 0
    };
    if (res instanceof import_stream5.Readable) {
      const output = new import_stream5.PassThrough();
      const parser = new import_json_node.JSONParser();
      parser.on("data", ({ value }) => {
        if (value.candidates || value.promptFeedback) {
          const obj = value;
          const block = obj.promptFeedback?.blockReason;
          if (block) return output.destroy(new Error(`Content blocked, reason: ${block}`));
          if (!obj.candidates) return output.destroy(new Error("Google API error, no candidates"));
          const candidate = obj.candidates[0];
          if (!candidate.content) return output.destroy(new Error(candidate.finishReason));
          data.content = candidate.content.parts[0].text || "";
          data.object = `chat.completion.chunk`;
          return output.write(JSON.stringify(data));
        } else return output;
      });
      parser.on("error", (e) => output.destroy(e));
      parser.on("end", () => output.end());
      res.pipe((0, import_iconv_lite5.decodeStream)("utf-8")).pipe(parser);
      return output;
    } else {
      const block = res.promptFeedback?.blockReason;
      if (block) throw new Error(`Content blocked, reason: ${block}`);
      if (!res.candidates) throw new Error("Google API error, no candidates");
      const candidate = res.candidates[0];
      if (!candidate.content) throw new Error(candidate.finishReason);
      data.content = candidate.content.parts[0].text || candidate.finishReason;
      data.object = `chat.completion`;
      return data;
    }
  }
  /**
   * Formats chat messages into GEMChatMessage format.
   * @param messages - An array of chat messages.
   * @returns A formatted array of GEMChatMessage.
   */
  async formatMessage(messages) {
    const prompt = [];
    let input = "";
    let base64 = null;
    for (const { role, content, img } of messages) {
      if (!content && !img) continue;
      if (role === "system" /* SYSTEM */) continue;
      if (img) base64 = await this.toBase64(img);
      if (role !== "assistant" /* ASSISTANT */) input += `
${content}`;
      else {
        input = input.trim();
        prompt.push({
          role: "user" /* USER */,
          parts: base64 ? [{ text: input || " " }, { inline_data: { mime_type: base64.mime, data: base64.data } }] : [{ text: input || " " }]
        });
        prompt.push({ role: "model" /* MODEL */, parts: [{ text: content }] });
        input = "";
      }
    }
    input = input.trim();
    prompt.push({
      role: "user" /* USER */,
      parts: base64 ? [{ text: input || " " }, { inline_data: { mime_type: base64.mime, data: base64.data } }] : [{ text: input || " " }]
    });
    return base64 ? [prompt[prompt.length - 1]] : prompt;
  }
  /**
   * Convert an image to base64 format object.
   * @param img The image string to convert.
   * @returns An object containing the MIME type and base64 data.
   */
  async toBase64(img) {
    let mime = "";
    let data = "";
    if (util_default.isBase64(img)) {
      if (util_default.isBase64(img, false)) {
        data = img;
        mime = "image/png";
      } else {
        const match = img.match(/^data:image\/([a-zA-Z]*);base64,([^\"']*)$/);
        if (match) {
          mime = `image/${match[1]}`;
          data = match[2];
        }
      }
    } else if (img.startsWith("http")) {
      const res = await util_default.get(img, {}, { responseType: "arraybuffer" });
      mime = `image/${["png", "jpg", "jpeg", "webp", "heic", "heif"].find((f) => img.toLowerCase().includes(f))?.replace("jpg", "jpeg") || "png"}`;
      data = res.toString("base64");
    } else {
      mime = `image/${(0, import_path3.extname)(img).replace(".", "").toLowerCase()}`;
      data = (0, import_fs3.readFileSync)(img).toString("base64");
    }
    if (!mime || !data) throw new Error("Can not transfer base64");
    return { mime, data };
  }
};

// src/providers/IFlyTek.ts
var import_crypto = require("crypto");
var import_os = require("os");
var import_stream6 = require("stream");
var import_node5 = __toESM(require("@server-sent-stream/node"));
var import_iconv_lite6 = require("iconv-lite");
var CHAT_API = "https://spark-api-open.xf-yun.com";
var IMAGINE_API = "https://spark-api.cn-huabei-1.xf-yun.com";
var STORAGE_KEY2 = "task_iflytek";
var IFlyTek = class {
  /**
   * Constructor for IFlyTek class.
   * @param key - The API key for MoonShot.
   * @param api - The API endpoint for proxy (optional).
   */
  constructor(pass, key, secret, appid, api = CHAT_API) {
    this.pass = pass;
    this.key = key;
    this.secret = secret;
    this.appid = appid;
    this.api = api;
  }
  /**
   * Initiates a chat conversation with IFLYTEK Spark API.
   *
   * @param messages - An array of chat messages.
   * @param model - The Spark model version to use (default: SPARK_DEFAULT_MODEL_VERSION).
   * @param stream - Whether to use stream response (default: false).
   * @param top - Top probability to sample (optional).
   * @param temperature - Temperature for sampling (optional).
   * @param maxLength - Maximum token length for response (optional).
   * @returns A promise resolving to the chat response or a stream.
   */
  async chat(messages, model = "lite" /* SPARK_LITE */, stream = false, top, temperature, maxLength, tools, toolChoice) {
    const key = Array.isArray(this.pass) ? util_default.getRandomKey(this.pass) : this.pass;
    if (!key) throw new Error("IFlyTek Spark API Password is not set in config");
    if (typeof top === "number") {
      if (top <= 0) top = 0.1;
      if (top > 1) top = 1;
    }
    if (typeof temperature === "number") {
      if (temperature < 0) temperature = 0;
      if (temperature > 2) temperature = 2;
    }
    const res = await util_default.post(
      `${this.api}/v1/chat/completions`,
      {
        model,
        messages: this.formatMessage(messages),
        stream,
        temperature,
        top_p: top,
        max_tokens: maxLength,
        tools,
        tool_choice: toolChoice
      },
      { headers: { Authorization: `Bearer ${key}` }, responseType: stream ? "stream" : "json" }
    );
    const data = {
      content: "",
      model,
      object: "",
      promptTokens: 0,
      completionTokens: 0,
      totalTokens: 0
    };
    if (res instanceof import_stream6.Readable) {
      const output = new import_stream6.PassThrough();
      const parser = new import_node5.default();
      parser.on("data", (e) => {
        const obj = util_default.json(e.data);
        if (!obj) return;
        if (obj.code) {
          output.destroy(new Error(obj.message));
          return;
        }
        data.content = obj.choices[0]?.delta?.content || "";
        if (obj.choices[0]?.delta?.tool_calls) data.tools = obj.choices[0]?.delta?.tool_calls;
        data.model = model;
        data.object = "chat.completion.chunk";
        data.promptTokens = obj.usage?.prompt_tokens || 0;
        data.completionTokens = obj.usage?.completion_tokens || 0;
        data.totalTokens = obj.usage?.total_tokens || 0;
        output.write(JSON.stringify(data));
      });
      parser.on("error", (e) => output.destroy(e));
      parser.on("end", () => output.end());
      res.pipe((0, import_iconv_lite6.decodeStream)("utf-8")).pipe(parser);
      return output;
    } else {
      data.content = res.choices[0]?.message?.content || "";
      if (res.choices[0]?.message?.tool_calls) data.tools = res.choices[0]?.message?.tool_calls;
      data.model = model;
      data.object = "chat.completion";
      data.promptTokens = res.usage?.prompt_tokens || 0;
      data.completionTokens = res.usage?.completion_tokens || 0;
      data.totalTokens = res.usage?.total_tokens || 0;
      return data;
    }
  }
  /**
   * Generate an image based on the given prompt.
   * @param prompt The prompt for image generation.
   * @param width The width of the image, default is 512.
   * @param height The height of the image, default is 512.
   * @param model The model to use for generating the image, default is IFlyTekImagineModel.V2.
   */
  async imagine(prompt, width = 512, height = 512, model = "v2.1" /* V2 */) {
    if (!this.appid) throw new Error("IFlyTek APP ID is not set in config");
    const url = this.getImagineURL(model);
    const res = await util_default.post(url, {
      header: { app_id: this.appid },
      payload: { message: { text: [{ role: "user", content: prompt }] } },
      parameter: { chat: { domain: "general", width, height } }
    });
    if (res.header.code !== 0) throw new Error(res.header.message);
    if (!res.payload) throw new Error("Fail to generate image, empty payload");
    const id = util_default.getRandomId();
    const imgs = [];
    for (const i in res.payload.choices.text)
      imgs.push(await util_default.writeFile(res.payload.choices.text[i].content, `${id}-${i}.png`));
    const time = Date.now();
    const task = {
      id,
      type: "generation" /* GENERATION */,
      info: "success",
      progress: 100,
      imgs,
      fail: "",
      created: time,
      model
    };
    const tasks = util_default.getItem(STORAGE_KEY2) || [];
    tasks.push(task);
    util_default.setItem(STORAGE_KEY2, tasks);
    return { taskId: task.id, time };
  }
  /**
   * Simulate tasks.
   *
   * @param id - The task ID to retrieve (optional).
   * @returns An array of task responses or a specific task by ID.
   */
  task(id) {
    const tasks = util_default.getItem(STORAGE_KEY2) || [];
    if (id) return tasks.filter((v) => v.id === id);
    else return tasks;
  }
  /**
   * Generates the Imagine API URL.
   *
   * @param model - The Spark imagine model.
   */
  getImagineURL(model) {
    if (!this.secret) throw new Error("IFlyTek API secret is not set in config");
    if (!this.key) throw new Error("IFlyTek API key is not set in config");
    const host = (0, import_os.hostname)();
    const date = (/* @__PURE__ */ new Date()).toUTCString();
    const algorithm = "hmac-sha256";
    const headers = "host date request-line";
    const signatureOrigin = `host: ${host}
date: ${date}
POST /${model}/tti HTTP/1.1`;
    const signatureSha = (0, import_crypto.createHmac)("sha256", this.secret).update(signatureOrigin).digest("hex");
    const signature = Buffer.from(signatureSha, "hex").toString("base64");
    const authorizationOrigin = `api_key="${this.key}", algorithm="${algorithm}", headers="${headers}", signature="${signature}"`;
    const authorization = Buffer.from(authorizationOrigin).toString("base64");
    return `${IMAGINE_API}/${model}/tti?authorization=${authorization}&date=${date}&host=${host}`;
  }
  /**
   * Format the chat message for IFlyTek Spark model.
   *
   * @param messages - Original chat messages
   */
  formatMessage(messages) {
    const prompt = [];
    for (const { role, content } of messages) {
      if (role === "developer" /* DEV */) continue;
      prompt.push({ role, content });
    }
    return prompt;
  }
};

// src/providers/Baidu.ts
var import_stream7 = require("stream");
var import_node6 = __toESM(require("@server-sent-stream/node"));
var import_iconv_lite7 = require("iconv-lite");
var API5 = "https://aip.baidubce.com";
var STORAGE_KEY3 = "baidu";
var Baidu = class {
  constructor(key, secret, api = API5) {
    this.key = key;
    this.secret = secret;
    this.api = api;
  }
  /**
   * Sends messages to the GLM chat model.
   *
   * @param messages - An array of chat messages.
   * @param model - The submodel to use for chat (default: ERNIE 8K).
   * @param stream - Whether to use stream response (default: false).
   * @param top - Top probability to sample (optional).
   * @param temperature - Temperature for sampling (optional).
   * @param maxLength - Maximum token length for response (optional).
   * @returns A promise resolving to the chat response or a stream.
   */
  async chat(messages, model = "completions" /* ERNIE_3_5 */, stream = false, top, temperature, maxLength) {
    if (typeof temperature === "number") {
      if (temperature <= 0) temperature = 0.1;
      if (temperature > 1) temperature = 1;
    }
    if (typeof top === "number") {
      if (top < 0) top = 0;
      if (top > 1) top = 1;
    }
    const token = await this.getAccessToken();
    const res = await util_default.post(
      `${this.api}/rpc/2.0/ai_custom/v1/wenxinworkshop/chat/${model}?access_token=${token}`,
      {
        messages: this.formatMessage(messages),
        system: messages[0]?.role === "system" /* SYSTEM */ ? messages[0].content : "",
        stream,
        temperature,
        top_p: top,
        max_output_tokens: maxLength
      },
      { responseType: stream ? "stream" : "json" }
    );
    const data = {
      content: "",
      model,
      object: "",
      promptTokens: 0,
      completionTokens: 0,
      totalTokens: 0
    };
    if (res instanceof import_stream7.Readable) {
      const output = new import_stream7.PassThrough();
      const parser = new import_node6.default();
      parser.on("data", (e) => {
        const obj = util_default.json(e.data);
        if (obj) {
          data.content = obj.result || "";
          data.model = model;
          data.object = obj.object;
          data.promptTokens = obj.usage?.prompt_tokens || 0;
          data.completionTokens = obj.usage?.completion_tokens || 0;
          data.totalTokens = obj.usage?.total_tokens || 0;
          output.write(JSON.stringify(data));
        }
      });
      parser.on("error", (e) => output.destroy(e));
      parser.on("end", () => output.end());
      res.pipe((0, import_iconv_lite7.decodeStream)("utf-8")).pipe(parser);
      return output;
    } else {
      if (res.error_code) throw new Error(res.error_msg);
      data.content = res.result || "";
      data.model = model;
      data.object = res.object;
      data.promptTokens = res.usage?.prompt_tokens || 0;
      data.completionTokens = res.usage?.completion_tokens || 0;
      data.totalTokens = res.usage?.total_tokens || 0;
      return data;
    }
  }
  // get baidu access token
  async getAccessToken() {
    if (!this.key) throw new Error("Baidu API key is not set in config");
    if (!this.secret) throw new Error("Baidu API secret is not set in config");
    const now = Date.now();
    const cache = util_default.getItem(STORAGE_KEY3);
    if (cache && cache.expires_in > now) return cache.access_token;
    const res = await util_default.get(`${this.api}/oauth/2.0/token`, {
      grant_type: "client_credentials",
      client_id: this.key,
      client_secret: this.secret
    });
    if (res.error) throw new Error(res.error_description);
    res.expires_in = now + res.expires_in * 1e3;
    util_default.setItem(STORAGE_KEY3, res);
    return res.access_token;
  }
  // format to baidu message
  formatMessage(messages) {
    const prompt = [];
    let input = "";
    const { USER, ASSISTANT, SYSTEM } = ChatRoleEnum;
    for (const { role, content } of messages) {
      if (!content.trim() || role === SYSTEM) continue;
      if (role !== ASSISTANT) input += `
${content}`;
      else {
        prompt.push({ role: USER, content: input.trim() || " " });
        prompt.push({ role: ASSISTANT, content });
        input = "";
      }
    }
    if (!input.trim()) throw new Error("User input nothing");
    prompt.push({ role: USER, content: input.trim() });
    return prompt;
  }
};

// src/providers/MoonShot.ts
var import_stream8 = require("stream");
var import_node7 = __toESM(require("@server-sent-stream/node"));
var import_iconv_lite8 = require("iconv-lite");
var API6 = "https://api.moonshot.cn";
var VER3 = "v1";
var MoonShot = class {
  /**
   * Constructor for MoonShot class.
   * @param key - The API key for MoonShot.
   * @param api - The API endpoint for proxy (optional).
   */
  constructor(key, api = API6) {
    this.key = key;
    this.api = api;
  }
  /**
   * Sends messages to the MoonShot chat model.
   *
   * @param messages - An array of chat messages.
   * @param model - The model to use for chat (default: moonshot-v1-8k).
   * @param stream - Whether to use stream response (default: false).
   * @param top - Top probability to sample (optional).
   * @param temperature - Temperature for sampling (optional).
   * @param maxLength - Maximum token length for response (optional).
   * @returns A promise resolving to the chat response or a stream.
   */
  async chat(messages, model = "moonshot-v1-8k" /* MOON_V1_8K */, stream = false, top, temperature, maxLength) {
    const key = Array.isArray(this.key) ? util_default.getRandomKey(this.key) : this.key;
    if (!key) throw new Error("MoonShot API key is not set in config");
    if (typeof temperature === "number") {
      if (temperature < 0) temperature = 0;
      if (temperature > 1) temperature = 1;
    }
    if (typeof top === "number") {
      if (top < 0) top = 0;
      if (top > 1) top = 1;
    }
    const res = await util_default.post(
      `${this.api}/${VER3}/chat/completions`,
      { model, messages: this.formatMessage(messages), stream, temperature, top_p: top, max_tokens: maxLength },
      { headers: { Authorization: `Bearer ${key}` }, responseType: stream ? "stream" : "json" }
    );
    const data = {
      content: "",
      model,
      object: "",
      promptTokens: 0,
      completionTokens: 0,
      totalTokens: 0
    };
    if (res instanceof import_stream8.Readable) {
      const output = new import_stream8.PassThrough();
      const parser = new import_node7.default();
      parser.on("data", (e) => {
        const obj = util_default.json(e.data);
        if (obj) {
          data.content = obj.choices[0]?.delta?.content || "";
          data.model = obj.model;
          data.object = obj.object;
          data.promptTokens = obj.usage?.prompt_tokens || 0;
          data.completionTokens = obj.usage?.completion_tokens || 0;
          data.totalTokens = obj.usage?.total_tokens || 0;
          output.write(JSON.stringify(data));
        }
      });
      parser.on("error", (e) => output.destroy(e));
      parser.on("end", () => output.end());
      res.pipe((0, import_iconv_lite8.decodeStream)("utf-8")).pipe(parser);
      return output;
    } else {
      data.content = res.choices[0]?.message?.content || "";
      data.model = res.model;
      data.object = res.object;
      data.promptTokens = res.usage?.prompt_tokens || 0;
      data.completionTokens = res.usage?.completion_tokens || 0;
      data.totalTokens = res.usage?.total_tokens || 0;
      return data;
    }
  }
  /**
   * Formats chat messages according to the GPT model's message format.
   *
   * @param messages - An array of chat messages.
   * @returns Formatted messages compatible with the GPT model.
   */
  formatMessage(messages) {
    const prompt = [];
    for (const { role, content } of messages) {
      if (role === "tool" /* TOOL */ || role === "developer" /* DEV */) continue;
      prompt.push({ role, content });
    }
    return prompt;
  }
};

// src/providers/MidJourney.ts
var MidJourney = class {
  // User token of MidJourney
  constructor(proxy, token, imgProxy) {
    this.proxy = proxy;
    this.token = token;
    this.imgProxy = imgProxy;
  }
  /**
   * Call the imagine API of MidJourney to generate text.
   * @param prompt - The input prompt text.
   * @param nPrompt - The excluded text.
   * @param width - The image width. Default value is 1.
   * @param height - The image height. Default value is 1.
   * @returns The generated text.
   */
  async imagine(prompt, nPrompt = "", width = 1024, height = 1024) {
    if (!this.proxy) throw new Error("MidJourney image model proxy is not set in config");
    const aspect = util_default.getAspect(width, height);
    const res = await util_default.post(
      `${this.proxy}/mj/submit/imagine`,
      { prompt: `${prompt} --ar ${aspect} ${nPrompt ? "--no " + nPrompt : ""}` },
      { headers: { "mj-api-secret": this.token } }
    );
    if (res.code !== 1) throw new Error(res.description);
    return { taskId: res.result, time: Date.now() };
  }
  /**
   * Get task information by id or get a list of imagining tasks.
   * @param id - The task id. If provided, it will return the task information with the specified id. Otherwise, it will return the task list.
   * @returns The task list or the task information with the specified id.
   */
  async task(id) {
    if (!this.proxy) throw new Error("MidJourney image model proxy is not set in config");
    if (id) {
      const res = await util_default.get(`${this.proxy}/mj/task/${id}/fetch`, null, {
        headers: { "mj-api-secret": this.token }
      });
      if (res.imageUrl && this.imgProxy) {
        const url = new URL(res.imageUrl);
        const pro = new URL(this.imgProxy);
        url.hostname = pro.hostname;
        url.protocol = pro.protocol;
        url.port = pro.port;
        res.imageUrl = url.toString();
      }
      return [
        {
          id: res.id,
          type: res.action,
          imgs: res.imageUrl ? [await util_default.writeFile(res.imageUrl, `${res.id}.png`)] : [],
          info: res.description,
          fail: res.failReason || "",
          progress: parseInt(res.progress) || 0,
          created: res.startTime,
          model: "midjourney" /* MJ */
        }
      ];
    } else {
      const res = await util_default.get(`${this.proxy}/mj/task/list`, null, {
        headers: { "mj-api-secret": this.token }
      });
      return res.map((v) => ({
        id: v.id,
        type: v.action,
        imgs: v.imageUrl ? [v.imageUrl] : [],
        info: v.description,
        fail: v.failReason || "",
        progress: parseInt(v.progress),
        created: v.startTime,
        model: "midjourney" /* MJ */
      }));
    }
  }
  /**
   * Submit a change request for a imagined task.
   * @param taskId - The task id.
   * @param action - The action type of the task.
   * @param index - The index for modification (optional).
   * @returns The modified task response.
   */
  async change(taskId, action, index) {
    if (!this.proxy) throw new Error("MidJourney image model proxy is not set in config");
    const res = await util_default.post(
      `${this.proxy}/mj/submit/change`,
      { taskId, action, index },
      { headers: { "mj-api-secret": this.token } }
    );
    return { taskId: res.result, time: Date.now() };
  }
};

// src/providers/Stability.ts
var API7 = "https://api.stability.ai";
var STORAGE_KEY4 = "task_stability_ai";
var Stability = class {
  constructor(key, api = API7) {
    this.key = key;
    this.api = api;
  }
  /**
   * Generate images using Stability AI.
   *
   * @param prompt - The main text prompt for image generation.
   * @param negativePrompt - The negative text prompt (optional).
   * @param width - Image width (default: 1024).
   * @param height - Image height (default: 1024).
   * @param samples - Number of images to generate (default: 1).
   * @param model - The Stability AI model to use (default: StabilityAIImagineModel.SD_1_6).
   * @returns A promise resolving to the image generation response.
   */
  async imagine(prompt, negativePrompt = "", width = 1024, height = 1024, samples = 1, model = "stable-diffusion-v1-6" /* SD_1_6 */) {
    const key = Array.isArray(this.key) ? util_default.getRandomKey(this.key) : this.key;
    if (!key) throw new Error("Stability key is not set in config");
    const prompts = [{ text: prompt, weight: 1 }];
    if (negativePrompt) prompts.push({ text: negativePrompt, weight: -1 });
    const res = await util_default.post(
      `${this.api}/v1/${"generation" /* GENERATION */}/${model}/text-to-image`,
      { width, height, samples, text_prompts: prompts },
      { headers: { Accept: "application/json", Authorization: `Bearer ${key}` } }
    );
    const id = util_default.getRandomId();
    const imgs = [];
    for (const i in res.artifacts) imgs.push(await util_default.writeFile(res.artifacts[i].base64, `${id}-${i}.png`));
    const time = Date.now();
    const task = {
      id,
      type: "generation" /* GENERATION */,
      info: res.artifacts[0].finishReason,
      progress: 100,
      imgs,
      fail: "",
      created: time,
      model
    };
    const tasks = util_default.getItem(STORAGE_KEY4) || [];
    tasks.push(task);
    util_default.setItem(STORAGE_KEY4, tasks);
    return { taskId: task.id, time };
  }
  /**
   * Simulate tasks or retrieve a specific task by ID.
   *
   * @param id - The task ID to retrieve (optional).
   * @returns An array of task responses or a specific task by ID.
   */
  task(id) {
    const tasks = util_default.getItem(STORAGE_KEY4) || [];
    if (id) return tasks.filter((v) => v.id === id);
    else return tasks;
  }
};

// src/providers/AliYun.ts
var import_stream9 = require("stream");
var import_node8 = __toESM(require("@server-sent-stream/node"));
var import_iconv_lite9 = require("iconv-lite");
var API8 = "https://dashscope.aliyuncs.com";
var VER4 = "v1";
var AliYun = class {
  /**
   * Constructor for AliYun class.
   * @param key - The API key for MoonShot.
   * @param api - The API endpoint for proxy (optional).
   */
  constructor(key, api = API8) {
    this.key = key;
    this.api = api;
  }
  /**
   * Fetches embeddings for input text.
   *
   * @param input - An array of input strings.
   * @param model - The model to use for embeddings (default: text-embedding-v3).
   * @param dimensions - The dimensions of output embedding vector (default: 1024)
   * @returns A promise resolving to the embedding response.
   */
  async embedding(input, model = "text-embedding-v3" /* ALI_V3 */, dimensions = 1024) {
    const key = Array.isArray(this.key) ? util_default.getRandomKey(this.key) : this.key;
    if (!key) throw new Error("AliYun API key is not set in config");
    const res = await util_default.post(
      `${this.api}/compatible-mode/${VER4}/embeddings`,
      { model, input, dimensions },
      { headers: { Authorization: `Bearer ${key}` }, responseType: "json" }
    );
    const data = {
      embedding: res.data.map((v) => v.embedding),
      object: "embedding",
      model,
      promptTokens: res.usage.prompt_tokens || 0,
      totalTokens: res.usage.total_tokens || 0
    };
    return data;
  }
  /**
   * Sends messages to the AliYun LLMs.
   *
   * @param messages - An array of chat messages.
   * @param model - The model to use for chat (default: moonshot-v1-8k).
   * @param stream - Whether to use stream response (default: false).
   * @param top - Top probability to sample (optional).
   * @param temperature - Temperature for sampling (optional).
   * @param maxLength - Maximum token length for response (optional).
   * @returns A promise resolving to the chat response or a stream.
   */
  async chat(messages, model = "qwen-turbo" /* QWEN_TURBO */, stream = false, top, temperature, maxLength) {
    const key = Array.isArray(this.key) ? util_default.getRandomKey(this.key) : this.key;
    if (!key) throw new Error("Qian Wen API key is not set in config");
    if (typeof temperature === "number") {
      if (temperature < 0) temperature = 0;
      if (temperature >= 2) temperature = 1.9;
    }
    if (typeof top === "number") {
      if (top <= 0) top = 0.1;
      if (top > 1) top = 1;
    }
    if (!["qwen-vl-max" /* QWEN_VL_MAX */, "qwen-vl-plus" /* QWEN_VL_PLUS */].includes(model))
      messages = messages.map(({ role, content }) => ({ role, content }));
    const res = await util_default.post(
      `${this.api}/compatible-mode/${VER4}/chat/completions`,
      {
        model,
        messages: this.formatMessage(messages),
        stream,
        temperature,
        top_p: top,
        max_tokens: maxLength
      },
      { headers: { Authorization: `Bearer ${key}` }, responseType: stream ? "stream" : "json" }
    );
    const data = {
      content: "",
      model,
      object: "",
      promptTokens: 0,
      completionTokens: 0,
      totalTokens: 0
    };
    if (res instanceof import_stream9.Readable) {
      const output = new import_stream9.PassThrough();
      const parser = new import_node8.default();
      parser.on("data", (e) => {
        const obj = util_default.json(e.data);
        if (obj) {
          data.content = obj?.choices[0]?.delta?.content || "";
          data.model = obj.model;
          data.object = obj.object;
          data.promptTokens = obj.usage?.prompt_tokens || 0;
          data.completionTokens = obj.usage?.completion_tokens || 0;
          data.totalTokens = obj.usage?.total_tokens || 0;
          output.write(JSON.stringify(data));
        }
      });
      parser.on("error", (e) => output.destroy(e));
      parser.on("end", () => output.end());
      res.pipe((0, import_iconv_lite9.decodeStream)("utf-8")).pipe(parser);
      return output;
    } else {
      data.content = res.choices[0]?.message?.content || "";
      if (res.choices[0]?.message?.tool_calls) data.tools = res.choices[0]?.message?.tool_calls;
      data.model = res.model;
      data.object = res.object || "chat.completion";
      data.promptTokens = res.usage?.prompt_tokens || 0;
      data.completionTokens = res.usage?.completion_tokens || 0;
      data.totalTokens = res.usage?.total_tokens || 0;
      return data;
    }
  }
  /**
   * Formats chat messages according to the GPT model's message format.
   *
   * @param messages - An array of chat messages.
   * @returns Formatted messages compatible with the GPT model.
   */
  formatMessage(messages) {
    const prompt = [];
    for (const { role, content, img } of messages) {
      if (role === "tool" /* TOOL */ || role === "developer" /* DEV */) continue;
      if (img) {
        if (!img.startsWith("http")) throw new Error("Invalid img HTTP URL");
        prompt.push({
          role: "user",
          content: [
            { type: "text", text: content },
            { type: "image_url", image_url: { url: img } }
          ]
        });
      } else prompt.push({ role, content });
    }
    return prompt;
  }
};

// src/providers/DeepSeek.ts
var import_stream10 = require("stream");
var import_node9 = __toESM(require("@server-sent-stream/node"));
var import_iconv_lite10 = require("iconv-lite");
var API9 = "https://api.deepseek.com";
var DeepSeek = class {
  /**
   * Constructor for MoonShot class.
   * @param key - The API key for MoonShot.
   * @param api - The API endpoint for proxy (optional).
   */
  constructor(key, api = API9) {
    this.key = key;
    this.api = api;
  }
  /**
   * Sends messages to the Ali QianWen chat model.
   *
   * @param messages - An array of chat messages.
   * @param model - The model to use for chat (default: moonshot-v1-8k).
   * @param stream - Whether to use stream response (default: false).
   * @param top - Top probability to sample (optional).
   * @param temperature - Temperature for sampling (optional).
   * @param maxLength - Maximum token length for response (optional).
   * @returns A promise resolving to the chat response or a stream.
   */
  async chat(messages, model = "deepseek-chat" /* DEEPSEEK_V3 */, stream = false, top, temperature, maxLength) {
    const key = Array.isArray(this.key) ? util_default.getRandomKey(this.key) : this.key;
    if (!key) throw new Error("DeepSeek API key is not set in config");
    if (typeof maxLength === "number") {
      if (maxLength < 1) maxLength = 1;
      if (maxLength > 8192) maxLength = 8192;
    }
    if (typeof temperature === "number") {
      if (temperature < 0) temperature = 0;
      if (temperature > 2) temperature = 2;
    }
    if (typeof top === "number") {
      if (top <= 0) top = 0.1;
      if (top > 1) top = 1;
    }
    const res = await util_default.post(
      `${this.api}/chat/completions`,
      {
        model,
        messages: this.formatMessage(messages),
        stream,
        temperature,
        top_p: top,
        max_tokens: maxLength
      },
      { headers: { Authorization: `Bearer ${key}` }, responseType: stream ? "stream" : "json" }
    );
    const data = {
      content: "",
      model,
      object: "",
      promptTokens: 0,
      completionTokens: 0,
      totalTokens: 0
    };
    if (res instanceof import_stream10.Readable) {
      const output = new import_stream10.PassThrough();
      const parser = new import_node9.default();
      parser.on("data", (e) => {
        const obj = util_default.json(e.data);
        if (obj) {
          data.content = obj.choices[0]?.delta?.content || "";
          data.model = obj.model;
          data.object = obj.object;
          data.promptTokens = obj.usage?.prompt_tokens || 0;
          data.completionTokens = obj.usage?.completion_tokens || 0;
          data.totalTokens = obj.usage?.total_tokens || 0;
          output.write(JSON.stringify(data));
        }
      });
      parser.on("error", (e) => output.destroy(e));
      parser.on("end", () => output.end());
      res.pipe((0, import_iconv_lite10.decodeStream)("utf-8")).pipe(parser);
      return output;
    } else {
      data.content = res.choices[0]?.message?.content || "";
      if (res.choices[0]?.message?.tool_calls) data.tools = res.choices[0]?.message?.tool_calls;
      data.model = res.model;
      data.object = res.object;
      data.promptTokens = res.usage?.prompt_tokens || 0;
      data.completionTokens = res.usage?.completion_tokens || 0;
      data.totalTokens = res.usage?.total_tokens || 0;
      return data;
    }
  }
  /**
   * Formats chat messages according to the GPT model's message format.
   *
   * @param messages - An array of chat messages.
   * @returns Formatted messages compatible with the GPT model.
   */
  formatMessage(messages) {
    const prompt = [];
    for (const { role, content, tool } of messages) {
      if (role === "developer" /* DEV */) continue;
      else if (role === "tool" /* TOOL */) prompt.push({ role, content, tool_call_id: tool });
      else prompt.push({ role, content });
    }
    return prompt;
  }
};

// src/providers/IX.ts
var import_stream11 = require("stream");
var import_node10 = __toESM(require("@server-sent-stream/node"));
var import_iconv_lite11 = require("iconv-lite");
var API10 = "https://api.x.ai";
var VER5 = "v1";
var XAI = class {
  /**
   * Constructor for the OpenAI class.
   *
   * @param key - The API key for OpenAI.
   * @param api - The API endpoint for proxy (optional).
   */
  constructor(key, api = API10) {
    this.key = key;
    this.api = api;
  }
  /**
   * Sends messages to the GPT chat model.
   *
   * @param messages - An array of chat messages.
   * @param model - The model to use for chat (default: gpt-3.5-turbo).
   * @param stream - Whether to use stream response (default: false).
   * @param top - Top probability to sample (optional).
   * @param temperature - Temperature for sampling (optional).
   * @param maxLength - Maximum token length for response (optional).
   * @param tools - Tools for model to use (optional).
   * @param toolChoice - Controls which (if any) tool is called by the model: none, required, auto (optional).
   * @returns A promise resolving to the chat response or a stream.
   */
  async chat(messages, model = "grok-2" /* GROK2 */, stream = false, top, temperature, maxLength, tools, toolChoice) {
    const key = Array.isArray(this.key) ? util_default.getRandomKey(this.key) : this.key;
    if (!key) throw new Error("X AI API key is not set in config");
    if (!["grok-2-vision" /* GROK2_VISION */].includes(model))
      messages = messages.map(({ role, content }) => ({ role, content }));
    if (typeof temperature === "number") {
      if (temperature < 0) temperature = 0;
      if (temperature > 2) temperature = 2;
    }
    if (typeof top === "number") {
      if (top < 0) top = 0;
      if (top > 1) top = 1;
    }
    const res = await util_default.post(
      `${this.api}/${VER5}/chat/completions`,
      {
        model,
        messages: this.formatMessage(messages),
        stream,
        temperature,
        top_p: top,
        max_tokens: maxLength,
        tools,
        tool_choice: toolChoice
      },
      { headers: { Authorization: `Bearer ${key}` }, responseType: stream ? "stream" : "json" }
    );
    const data = {
      content: "",
      model,
      object: "",
      promptTokens: 0,
      completionTokens: 0,
      totalTokens: 0
    };
    if (res instanceof import_stream11.Readable) {
      const output = new import_stream11.PassThrough();
      const parser = new import_node10.default();
      parser.on("data", (e) => {
        const obj = util_default.json(e.data);
        if (obj) {
          data.content = obj.choices[0]?.delta?.content || "";
          data.model = obj.model;
          data.object = obj.object;
          data.promptTokens = obj.usage?.prompt_tokens || 0;
          data.completionTokens = obj.usage?.completion_tokens || 0;
          data.totalTokens = obj.usage?.total_tokens || 0;
          output.write(JSON.stringify(data));
        }
      });
      parser.on("error", (e) => output.destroy(e));
      parser.on("end", () => output.end());
      res.pipe((0, import_iconv_lite11.decodeStream)("utf-8")).pipe(parser);
      return output;
    } else {
      data.content = res.choices[0]?.message?.content || "";
      if (res.choices[0]?.message?.tool_calls) data.tools = res.choices[0]?.message?.tool_calls;
      data.model = res.model;
      data.object = res.object;
      data.promptTokens = res.usage?.prompt_tokens || 0;
      data.completionTokens = res.usage?.completion_tokens || 0;
      data.totalTokens = res.usage?.total_tokens || 0;
      return data;
    }
  }
  /**
   * Formats chat messages according to the GPT model's message format.
   *
   * @param messages - An array of chat messages.
   * @returns Formatted messages compatible with the GPT model.
   */
  formatMessage(messages) {
    const prompt = [];
    for (const { role, content, img } of messages) {
      switch (role) {
        case "user" /* USER */:
          if (img)
            prompt.push({
              role,
              content: [
                { type: "text", text: content },
                { type: "image_url", image_url: { url: img } }
              ]
            });
          else prompt.push({ role, content });
          break;
        case ("assistant" /* ASSISTANT */ || "system" /* SYSTEM */):
          prompt.push({ role, content });
          break;
        default:
          break;
      }
    }
    return prompt;
  }
};

// src/UniAI.ts
var DEFAULT_MESSAGE = "Hi, who are you? Answer in 10 words!";
var UniAI = class {
  constructor(config = {}) {
    this.config = null;
    this.config = config;
    this.openai = new OpenAI(config.OpenAI?.key, config.OpenAI?.proxy);
    this.anthropic = new Anthropic(config.Anthropic?.key, config.Anthropic?.proxy);
    this.deepseek = new DeepSeek(config.DeepSeek?.key, config.DeepSeek?.proxy);
    this.glm = new GLM(config.GLM?.key, config.GLM?.proxy);
    this.google = new Google(config.Google?.key, config.Google?.proxy);
    this.fly = new IFlyTek(
      config.IFlyTek?.apiPassword,
      config.IFlyTek?.appId,
      config.IFlyTek?.apiKey,
      config.IFlyTek?.apiSecret,
      config.IFlyTek?.proxy
    );
    this.baidu = new Baidu(config.Baidu?.apiKey, config.Baidu?.secretKey, config.Baidu?.proxy);
    this.moon = new MoonShot(config.MoonShot?.key, config.MoonShot?.proxy);
    this.ali = new AliYun(config.AliYun?.key, config.AliYun?.proxy);
    this.xai = new XAI(config.XAI?.key, config.XAI?.proxy);
    this.other = new Other(config.Other?.api, config.Other?.key);
    this.mj = new MidJourney(config.MidJourney?.proxy, config.MidJourney?.token, config.MidJourney?.imgProxy);
    this.stability = new Stability(config.StabilityAI?.key, config.StabilityAI?.proxy);
    this.chatModels = Object.entries(ChatModelProvider).map(([k, v]) => ({
      provider: k,
      value: v,
      models: Object.values(
        {
          ["openai" /* OpenAI */]: OpenAIChatModel,
          ["anthropic" /* Anthropic */]: AnthropicChatModel,
          ["deepseek" /* DeepSeek */]: DeepSeekChatModel,
          ["baidu" /* Baidu */]: BaiduChatModel,
          ["iflytek" /* IFlyTek */]: IFlyTekChatModel,
          ["glm" /* GLM */]: GLMChatModel,
          ["google" /* Google */]: GoogleChatModel,
          ["moonshot" /* MoonShot */]: MoonShotChatModel,
          ["aliyun" /* AliYun */]: AliChatModel,
          ["xai" /* XAI */]: XAIChatModel,
          ["other" /* Other */]: []
        }[v]
      )
    }));
    this.imgModels = Object.entries(ImagineModelProvider).map(([k, v]) => ({
      provider: k,
      value: v,
      models: Object.values(
        {
          ["openai" /* OpenAI */]: OpenAIImagineModel,
          ["midjourney" /* MidJourney */]: MidJourneyImagineModel,
          ["stability.ai" /* StabilityAI */]: StabilityAIImagineModel,
          ["iflytek" /* IFlyTek */]: IFlyTekImagineModel
        }[v]
      )
    }));
    this.embedModels = Object.entries(EmbedModelProvider).map(([k, v]) => ({
      provider: k,
      value: v,
      models: Object.values(
        {
          ["openai" /* OpenAI */]: OpenAIEmbedModel,
          ["glm" /* GLM */]: GLMEmbedModel,
          ["google" /* Google */]: GoogleEmbedModel,
          ["aliyun" /* AliYun */]: AliEmbedModel,
          ["other" /* Other */]: OtherEmbedModel
        }[v]
      )
    }));
    this.models = [...this.chatModels, ...this.embedModels, ...this.imgModels];
  }
  async chat(messages = DEFAULT_MESSAGE, option = {}) {
    if (typeof messages === "string") messages = [{ role: "user" /* USER */, content: messages }];
    const provider = option.provider || "openai" /* OpenAI */;
    const { model, stream, top, temperature, maxLength, tools, toolChoice } = option;
    switch (provider) {
      case "openai" /* OpenAI */:
        return await this.openai.chat(
          messages,
          model,
          stream,
          top,
          temperature,
          maxLength,
          tools,
          toolChoice
        );
      case "anthropic" /* Anthropic */:
        return await this.anthropic.chat(
          messages,
          model,
          stream,
          top,
          temperature,
          maxLength,
          tools,
          toolChoice
        );
      case "deepseek" /* DeepSeek */:
        return await this.deepseek.chat(
          messages,
          model,
          stream,
          top,
          temperature,
          maxLength
        );
      case "google" /* Google */:
        return await this.google.chat(messages, model, stream, top, temperature, maxLength);
      case "glm" /* GLM */:
        return await this.glm.chat(
          messages,
          model,
          stream,
          top,
          temperature,
          maxLength,
          tools,
          toolChoice
        );
      case "iflytek" /* IFlyTek */:
        return await this.fly.chat(
          messages,
          model,
          stream,
          top,
          temperature,
          maxLength,
          tools,
          toolChoice
        );
      case "baidu" /* Baidu */:
        return await this.baidu.chat(messages, model, stream, top, temperature, maxLength);
      case "moonshot" /* MoonShot */:
        return await this.moon.chat(messages, model, stream, top, temperature, maxLength);
      case "aliyun" /* AliYun */:
        return await this.ali.chat(messages, model, stream, top, temperature, maxLength);
      case "xai" /* XAI */:
        return await this.xai.chat(
          messages,
          model,
          stream,
          top,
          temperature,
          maxLength,
          tools,
          toolChoice
        );
      case "other" /* Other */:
        return await this.other.chat(
          messages,
          model,
          stream,
          top,
          temperature,
          maxLength,
          tools,
          toolChoice
        );
      default:
        throw new Error("Chat model Provider not found");
    }
  }
  async embedding(content, option = {}) {
    const provider = option.provider || ModelProvider.OpenAI;
    const { model } = option;
    if (typeof content === "string") content = [content];
    switch (provider) {
      case "openai" /* OpenAI */:
        return await this.openai.embedding(content, model);
      case "glm" /* GLM */:
        return await this.glm.embedding(content, model, option.dimensions);
      case "google" /* Google */:
        return await this.google.embedding(content, model);
      case "aliyun" /* AliYun */:
        return await this.ali.embedding(content, model, option.dimensions);
      case "other" /* Other */:
        return await this.other.embedding(content, model);
      default:
        throw new Error("Embedding model provider not found");
    }
  }
  async imagine(prompt, option = {}) {
    const provider = option.provider || "openai" /* OpenAI */;
    const { negativePrompt, width, height, num, model } = option;
    if (provider === "openai" /* OpenAI */)
      return await this.openai.imagine(prompt, width, height, num, model);
    else if (provider === "midjourney" /* MidJourney */)
      return await this.mj.imagine(prompt, negativePrompt, width, height);
    else if (provider === "stability.ai" /* StabilityAI */)
      return await this.stability.imagine(
        prompt,
        negativePrompt,
        width,
        height,
        num,
        model
      );
    else if (provider === "iflytek" /* IFlyTek */)
      return await this.fly.imagine(prompt, width, height, model);
    else throw new Error("Imagine model provider not found");
  }
  async task(provider, id) {
    if (provider === "openai" /* OpenAI */) return this.openai.task(id);
    else if (provider === "midjourney" /* MidJourney */) return await this.mj.task(id);
    else if (provider === "stability.ai" /* StabilityAI */) return this.stability.task(id);
    else if (provider === "iflytek" /* IFlyTek */) return this.fly.task(id);
    else throw new Error("Imagine model provider not found");
  }
  async change(provider, taskId, action, index) {
    if (provider === "midjourney" /* MidJourney */) return this.mj.change(taskId, action, index);
    else throw new Error("Imagine model provider not found");
  }
};

// src/Prompt.ts
var Prompt = class _Prompt {
  /**
   * Constructs a new Prompt instance.
   * @param title - The heading/title of the node.
   * @param content - The content/body text of the node. Defaults to an empty string.
   * @param children - An array of Prompt children. Defaults to an empty array.
   */
  constructor(title, content = "", children = []) {
    this.title = title;
    this.content = content;
    this.children = children;
  }
  /**
   * Recursively finds all descendant nodes (including direct children) whose title matches the given string.
   * @param title - The title to search for.
   * @param deep - Whether to search recursively in all descendants. Defaults to false (only immediate children).
   * @returns An array of all matching Prompt nodes.
   */
  getByTitle(title, deep = false) {
    let result = [];
    for (const child of this.children) {
      if (child.title === title) result.push(child);
      if (deep) result = result.concat(child.getByTitle(title, true));
    }
    return result;
  }
  /**
   * Adds a child prompt node to the children of this node.
   * Supports chainable calls.
   * @param child - The Prompt instance to add.
   * @returns This Prompt instance (for chaining).
   */
  add(child) {
    this.children.push(child);
    return this;
  }
  /**
   * Recursively removes all nodes (including direct and indirect children) whose title matches the given string.
   * @param title - The title of the nodes to remove.
   * @param deep - Whether to remove matching nodes at any depth. Defaults to false (only immediate children).
   * @returns An array of all removed Prompt nodes.
   */
  remove(title, deep = false) {
    const removed = [];
    for (let i = this.children.length - 1; i >= 0; i--)
      if (this.children[i].title === title) removed.push(...this.children.splice(i, 1));
    if (deep) for (const child of this.children) removed.push(...child.remove(title, true));
    return removed;
  }
  /**
   * Recursively exports the structure as Markdown text.
   * @param level - The Markdown heading level (used internally for recursion).
   * @returns The generated Markdown string.
   */
  toMarkdown(level = 1) {
    let md = "";
    if (this.title) md += `${"#".repeat(level)} ${this.title}

`;
    if (this.content) md += this.content.trim() + "\n\n";
    for (const child of this.children) md += child.toMarkdown(level + 1);
    return md;
  }
  /**
   * Creates a deep copy (clone) of this Prompt node, including all descendants.
   * @returns A new Prompt instance that is a deep copy of this node.
   */
  clone() {
    return new _Prompt(
      this.title,
      this.content,
      this.children.map((child) => child.clone())
    );
  }
  /**
   * Serializes this node and all descendants into a plain JSON object structure.
   * Only the title, content, and children structure are preserved.
   * @returns The JSON representation of this Prompt tree.
   */
  toJSON() {
    return {
      title: this.title,
      content: this.content,
      children: this.children.map((child) => child.toJSON())
    };
  }
  /**
   * Converts this Prompt node and all descendants into a Markdown string.
   * @returns The Markdown representation of this Prompt tree.
   */
  toString() {
    return this.toMarkdown();
  }
  /**
   * Deserializes a JSON object (or string) into a Prompt tree.
   * @param jsonObj - The structured data (from toJSON) or a compatible JSON string.
   * @returns The root Prompt instance.
   */
  static fromJSON(jsonObj) {
    if (typeof jsonObj === "string") jsonObj = JSON.parse(jsonObj);
    return new _Prompt(
      jsonObj.title,
      jsonObj.content,
      (jsonObj.children || []).map((child) => _Prompt.fromJSON(child))
    );
  }
  /**
   * Parses a Markdown source string and constructs a Prompt tree representing its structure.
   * Only basic heading recognition (# ... ######) is implemented.
   * @param markdown - The Markdown source string.
   * @returns The root Prompt node parsed from the document.
   */
  static fromMarkdown(markdown) {
    const lines = markdown.split("\n");
    const root = new _Prompt("", "", []);
    const stack = [{ prompt: root, level: 0 }];
    for (const line of lines) {
      const headingMatch = line.match(/^(#{1,6})\s+(.*)$/);
      if (headingMatch) {
        const level = headingMatch[1].length;
        const title = headingMatch[2].trim();
        const newNode = new _Prompt(title, "");
        while (stack.length && stack[stack.length - 1].level >= level) stack.pop();
        stack[stack.length - 1].prompt.add(newNode);
        stack.push({ prompt: newNode, level });
      } else if (line.trim() !== "") {
        if (stack.length > 0) {
          const current = stack[stack.length - 1].prompt;
          if (current.content) current.content += "\n";
          current.content += line.trim();
        }
      }
    }
    if (root.children.length === 1) return root.children[0];
    return new _Prompt("Document", "", root.children);
  }
  /**
   * Generates an Abstract Syntax Tree (AST) representing this node and all descendants,
   * compatible with mdast structure.
   * @returns The generated AST object.
   */
  getAST() {
    const astNode = {
      type: this.title ? "heading" : "root",
      depth: this.title ? 1 : void 0,
      children: []
    };
    if (this.title) astNode.children.push({ type: "text", value: this.title });
    if (this.content)
      astNode.children.push({
        type: "paragraph",
        children: [{ type: "text", value: this.content }]
      });
    for (const child of this.children) astNode.children.push(child.getAST());
    return astNode;
  }
  /**
   * Prints the tree structure of this Prompt node and all descendants to the console,
   * with clear indentation and branch markers for visualization.
   * @param indent - The indentation prefix for current level (for internal recursion use).
   * @param isLast - Whether this is the last child node (for internal recursion use).
   */
  printTree(indent = "", isLast = true) {
    const icon = indent ? isLast ? "\u2514\u2500" : "\u251C\u2500" : "";
    if (this.title || this.content)
      console.log(
        `${indent}${icon}${this.title ? `\u300C${this.title}\u300D` : ""}${this.content ? `: ${this.content.split("\n")[0]}${this.content.length > 40 ? "..." : ""}` : ""}`
      );
    const nextIndent = indent + (isLast ? "  " : "\u2502 ");
    this.children.forEach((child, i) => child.printTree(nextIndent, i === this.children.length - 1));
  }
};

// src/index.ts
var index_default = UniAI;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  AliChatModel,
  AliEmbedModel,
  AnthropicChatModel,
  AnthropicChatRoleEnum,
  BDUChatRoleEnum,
  BaiduChatModel,
  ChatModel,
  ChatModelProvider,
  ChatRoleEnum,
  DETaskType,
  DSChatRoleEnum,
  DeepSeekChatModel,
  EmbedModel,
  EmbedModelProvider,
  GEMChatRoleEnum,
  GLMChatModel,
  GLMChatRoleEnum,
  GLMEmbedModel,
  GPTChatRoleEnum,
  GoogleChatModel,
  GoogleEmbedModel,
  IFlyTekChatModel,
  IFlyTekImagineModel,
  ImagineModel,
  ImagineModelProvider,
  ImgTaskType,
  MJTaskType,
  MidJourneyImagineModel,
  ModelModel,
  ModelProvider,
  MoonShotChatModel,
  OpenAIChatModel,
  OpenAIEmbedModel,
  OpenAIImagineModel,
  OtherEmbedModel,
  Prompt,
  SDTaskType,
  SPKChatRoleEnum,
  SPKTaskType,
  StabilityAIImagineModel,
  XAIChatModel
});
